/* Refonte Halezia, étape 02, passe 2 (19/10/2026). Chargé (defer) par la section « Custom Liquid »
   vs_refonte_css du groupe d'en-tête. Code à nous : aucun fichier JS du thème Honey n'est modifié.

   Fiche produit, mobile (1000 px et moins) : la barre d'ajout collante NATIVE de Honey n'apparaissait
   qu'après avoir dépassé le bouton d'ajout, qui reste sous le premier écran (galerie carrée, vignettes,
   variantes : 1 135 px sur un écran de 844). Ici, la barre rappelle le choix en cours (couleur, taille, prix),
   pour qu'on n'ajoute pas une taille qu'on n'a pas vue. Le bouton de la barre est celui du thème (même formulaire).
   Passe 14 (04/11/2026, Solal : « après le bouton ») : la barre n'apparaît qu'une fois le bouton principal passé
   AU-DESSUS de l'écran (plus avant qu'on l'ait vu) ; js/75-fiche-p12.js tient la même règle au défilement.
   Classe posée : .vs-barre-visible sur [data-controls-group-submit] ; CSS dans vs-refonte.css. */
(function () {
  var mq = window.matchMedia('(max-width: 1000px)');
  var observateur = null;

  function prix(centimes) {
    try {
      return (centimes / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return (centimes / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function varianteCourante(info) {
    var s = info && info.querySelector('script[data-selected-variant]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function poserChoix(groupe, variante) {
    var contenu = groupe.querySelector('.product-form__button--fixed__content');
    if (!contenu || !variante) return;
    var choix = contenu.querySelector('.vs-barre__choix');
    if (!choix) {
      choix = document.createElement('div');
      choix.className = 'vs-barre__choix';
      choix.setAttribute('aria-hidden', 'true');
      contenu.insertBefore(choix, contenu.firstChild);
    }
    var titre = (variante.title || '').split(' / ').join(' · ');
    choix.innerHTML = '';
    if (titre && titre !== 'Default Title') {
      var t = document.createElement('span');
      t.className = 'vs-barre__variante';
      t.textContent = titre;
      choix.appendChild(t);
    }
    var p = document.createElement('span');
    p.className = 'vs-barre__prix';
    p.textContent = prix(variante.price);
    choix.appendChild(p);
  }

  function installer() {
    if (observateur) { observateur.disconnect(); observateur = null; }
    var info = document.querySelector('.product-single__meta') || document;
    var groupe = info.querySelector('[data-controls-group-submit]');
    if (!groupe || !groupe.querySelector('.product-form__button--fixed')) return;
    var bouton = Array.prototype.find.call(info.querySelectorAll('button[data-add-to-cart]'), function (b) {
      return !b.closest('.product-form__button--fixed');
    });
    if (!bouton) return;
    poserChoix(groupe, varianteCourante(info));
    if (!mq.matches || !('IntersectionObserver' in window)) { groupe.classList.remove('vs-barre-visible'); return; }
    observateur = new IntersectionObserver(function (entrees) {
      var e = entrees[entrees.length - 1];
      groupe.classList.toggle('vs-barre-visible', !e.isIntersecting && e.boundingClientRect.bottom <= 0);
    }, { threshold: 0 });
    observateur.observe(bouton);
  }

  function demarrer() {
    installer();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        // Honey remplace une partie du bloc d'achat après un changement de variante : on réinstalle.
        setTimeout(function () {
          installer();
          var groupe = document.querySelector('[data-controls-group-submit]');
          if (groupe && ev && ev.data && ev.data.variant) poserChoix(groupe, ev.data.variant);
        }, 60);
      });
    }
    if (mq.addEventListener) mq.addEventListener('change', installer);
  }

  if (!document.querySelector('[data-controls-group-submit]')) return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();

/* Fiche : le lien « Quelle taille choisir ? » (vs-lien-tailles), sous les boutons de taille, ouvre le guide
   (accordéon vs-guide-tailles, plus bas dans la page) et y amène. */
document.addEventListener('click', function (e) {
  var lien = e.target.closest && e.target.closest('[data-vs-ouvrir-guide]');
  if (!lien) return;
  var guide = document.querySelector('[data-vs-guide-tailles]');
  if (!guide) return;
  e.preventDefault();
  guide.open = true;
  guide.scrollIntoView({ behavior: 'smooth', block: 'start' });
  var resume = guide.querySelector('summary');
  if (resume) setTimeout(function () { resume.focus({ preventScroll: true }); }, 400);
});

/* Accueil : le long texte SEO (section rich_text_RTjhrG) est replié derrière « Lire la suite ».
   Le texte reste dans la page (indexé), seul l'affichage est raccourci. */
(function () {
  var bloc = document.querySelector('[id$="__rich_text_RTjhrG"] .rich-text__text, [id$="__rich_text_RTjhrG"] .rte');
  if (!bloc || bloc.scrollHeight < 420) return;
  bloc.classList.add('vs-replie');
  var b = document.createElement('button');
  b.type = 'button';
  b.className = 'vs-lire-suite';
  b.setAttribute('aria-expanded', 'false');
  b.textContent = 'Lire la suite';
  b.addEventListener('click', function () {
    var ouvert = bloc.classList.toggle('vs-replie') === false;
    b.setAttribute('aria-expanded', String(ouvert));
    b.textContent = ouvert ? 'Réduire' : 'Lire la suite';
  });
  bloc.insertAdjacentElement('afterend', b);
})();


/* =====================================================================================================
   Passe 3 (20/10/2026)
   ===================================================================================================== */

/* Tiroir panier : date de livraison estimée (vs-tiroir-livraison). Fourchette en jours ouvrés depuis la commande
   (data-min, data-max : 8 et 14, mesurés sur 191 livraisons), week-ends et fériés fixes exclus (les fériés mobiles
   ne sont pas comptés : l'estimation peut avancer d'un jour autour de Pâques et de l'Ascension). Le tiroir est
   redessiné par le thème à chaque ajout : on repose la date à chaque fois. */
(function () {
  var FERIES = ['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'];
  function ouvre(d) {
    var j = d.getDay();
    var cle = ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    return j !== 0 && j !== 6 && FERIES.indexOf(cle) === -1;
  }
  function plusOuvres(depart, n) {
    var d = new Date(depart.getFullYear(), depart.getMonth(), depart.getDate());
    while (n > 0) { d.setDate(d.getDate() + 1); if (ouvre(d)) n--; }
    return d;
  }
  function texte(a, b) {
    var mois = function (d) { return d.toLocaleDateString('fr-FR', { month: 'long' }); };
    var jour = function (d) { return d.getDate() === 1 ? '1er' : String(d.getDate()); };
    if (a.getMonth() === b.getMonth()) return 'estimée entre le ' + jour(a) + ' et le ' + jour(b) + ' ' + mois(b);
    return 'estimée entre le ' + jour(a) + ' ' + mois(a) + ' et le ' + jour(b) + ' ' + mois(b);
  }
  function poser(racine) {
    var blocs = (racine || document).querySelectorAll('[data-vs-livraison]');
    if (!blocs.length) return;
    var auj = new Date();
    for (var i = 0; i < blocs.length; i++) {
      var bloc = blocs[i], cible = bloc.querySelector('[data-vs-livraison-date]');
      if (!cible || bloc.getAttribute('data-vs-pose') === '1') continue;
      var min = parseInt(bloc.getAttribute('data-min'), 10) || 6, max = parseInt(bloc.getAttribute('data-max'), 10) || 9;
      try {
        cible.textContent = (bloc.getAttribute('data-prefixe') || '') + texte(plusOuvres(auj, min), plusOuvres(auj, max));
        bloc.setAttribute('data-vs-pose', '1');
      } catch (e) { /* la phrase de secours reste */ }
    }
  }
  function demarrer() {
    poser(document);
    var tiroir = document.querySelector('cart-drawer');
    if (tiroir && 'MutationObserver' in window) {
      new MutationObserver(function () { poser(tiroir); }).observe(tiroir, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();

/* Tiroir panier : Échap ferme le tiroir où que soit le focus (le thème n'écoute la touche que dans le tiroir). */
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var tiroir = document.querySelector('cart-drawer.drawer.active, cart-drawer.active');
  if (tiroir && typeof tiroir.close === 'function') tiroir.close();
});

/* Fiche : « Couleur: Taupe » devient « Couleur : Taupe » (espace insécable avant les deux-points, typographie
   française). Le libellé vient du thème ; on corrige le texte affiché, au chargement et après chaque changement
   de variante (Honey redessine le bloc). */
(function () {
  function corriger() {
    var l = document.querySelectorAll('legend.product-form__label');
    for (var i = 0; i < l.length; i++) {
      var n = l[i].firstChild;
      while (n && n.nodeType !== 3) n = n.nextSibling;
      if (n && /\S\s*:\s*$/.test(n.nodeValue) && n.nodeValue.indexOf(' :') === -1) {
        n.nodeValue = n.nodeValue.replace(/\s*:\s*$/, ' : ');
      }
    }
  }
  if (!document.querySelector('legend.product-form__label')) return;
  corriger();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(corriger, 80); });
  }
})();


/* =====================================================================================================
   Passe 4 (premium, 20/10/2026)
   ===================================================================================================== */

/* Entrées des blocs à nous (tuiles « Trouvez votre plaid » de l'accueil) : les blocs du thème ont leurs entrées
   natives (.scroll-animate, réglées dans vs-refonte.css) ; les nôtres montent de la même façon, en cascade de 70 ms,
   et leur photo se pose (106 % vers 100 %). Sans JS, sans IntersectionObserver ou avec « réduire les animations »,
   rien n'est masqué : la classe vs-anime n'est posée qu'ici, après le marquage. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var blocs = [];
  var tete = document.querySelectorAll('.vs-tuiles__tete > *');
  for (var i = 0; i < tete.length; i++) { tete[i].style.setProperty('--vs-delai', (i * 80) + 'ms'); blocs.push(tete[i]); }
  var tuiles = document.querySelectorAll('.vs-tuiles__grille > li');
  for (var j = 0; j < tuiles.length; j++) { tuiles[j].style.setProperty('--vs-delai', ((j % 4) * 70) + 'ms'); blocs.push(tuiles[j]); }
  if (!blocs.length) return;
  var io = new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('vs-vu');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -6% 0px' });
  blocs.forEach(function (b) { b.classList.add('vs-entre'); io.observe(b); });
  document.documentElement.classList.add('vs-anime');
})();

/* Retour d'ajout au panier : le bouton de la fiche passe à « Ajouté » pendant 1,6 s quand le tiroir s'ouvre
   (le thème ouvre le tiroir ; le bouton ne disait rien). Le libellé d'origine revient ensuite. */
(function () {
  var tiroir = document.querySelector('cart-drawer');
  if (!tiroir || !('MutationObserver' in window)) return;
  var bouton = null, libelle = null, minuterie = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[data-add-to-cart]');
    if (b) bouton = b;
  }, true);
  new MutationObserver(function () {
    if (!bouton || !tiroir.classList.contains('active')) return;
    var cible = bouton.querySelector('[data-add-to-cart-text]') || bouton.querySelector('span');
    bouton = null;
    if (!cible) return;
    if (libelle === null) libelle = cible.textContent;
    cible.textContent = 'Ajouté au panier';
    cible.closest('button').classList.add('vs-ajoute');
    clearTimeout(minuterie);
    minuterie = setTimeout(function () {
      cible.textContent = libelle; libelle = null;
      var bt = cible.closest('button'); if (bt) bt.classList.remove('vs-ajoute');
    }, 1600);
  }).observe(tiroir, { attributes: true, attributeFilter: ['class'] });
})();

/* Halezia, 02/11/2026 (Solal) : à la fermeture du menu, du panier ou de « Trouver ma taille », le navigateur rend le focus
   au bouton d'ouverture et l'encadre, même après un toucher ou un clic. L'anneau ne sert qu'au clavier : la classe
   vs-clavier sur <html> suit la dernière façon d'interagir ; sans elle, pas d'anneau (css/99-p13-live.css). */
(function () {
  var html = document.documentElement;
  var TOUCHES = /^(Tab|Escape|Enter| |Arrow|Home|End|Page)/;
  document.addEventListener('keydown', function (e) {
    if (TOUCHES.test(e.key) && !e.metaKey && !e.ctrlKey && !e.altKey) html.classList.add('vs-clavier');
  }, true);
  document.addEventListener('pointerdown', function () { html.classList.remove('vs-clavier'); }, true);
})();

/* =====================================================================================================
   Conseil de taille. Passes 7 et 8 (28/10/2026) : le modèle et le dessin ; passe 10 (29/10) : en surcouche ;
   passe 13 (02/11) : le studio en 3D et le mode « Moi ».
   ===================================================================================================== */

/* Modèle (passe 8, retours 4, 5 et 6 de Solal) : il utilise LES DEUX côtés du plaid.
   - Canapé, vue de face : le grand côté suit la longueur du canapé (accoudoirs compris) et retombe à l'extérieur des
     accoudoirs ; le petit côté passe sur le dossier (20 cm dessus, 41 cm de face) et l'assise (55 cm), le reste
     retombe devant l'assise (34 cm au plus, jusqu'aux pieds).
   - Lit, vue de dessus, tête à gauche : un plaid qui dépasse le lit d'au moins 15 cm de chaque côté (et assez long)
     se pose sur tout le lit, sous les oreillers, et retombe au pied (50 cm au plus) ; sinon il se pose en travers du
     pied de lit, le grand côté dans la largeur. Ce qui dépasse du matelas retombe : dessiné plus foncé.
   - Moi (passe 13) : le plaid en châle, le grand côté autour des épaules, le petit côté qui descend ; épaules à 82 % de
     la taille, tour des épaules à 62 % (105 cm pour 1,70 m) ; il « croise devant » au-delà de 130 % de ce tour.
   Surcouche : <dialog> vs-tm (snippet vs-conseil) ouvert par « Trouver ma taille », posé à côté du libellé « Taille »,
   et par le verdict sous les tailles ; panneau large sur ordinateur (la scène à gauche), plein écran sur mobile (la
   scène en haut ; glisser l'en-tête vers le bas pour fermer). Scène : assets/vs13-plaid3d.js (VSPlaid3D), chargé à la
   première ouverture (préchargé au survol du bouton) ; sans WebGL ou si le chargement échoue, le plan coté de la
   passe 14 la remplace (mode « Moi » compris). Passe 14 (04/11) : vue « Plan coté » à côté des vues de la scène. Un format choisi dans le panneau coche la taille de la fiche (bouton de
   Honey cliqué, sa logique de variante suit) ; « Ajouter au panier » du panneau ferme la surcouche et clique le bouton
   d'ajout de la fiche quand la variante de Honey est bien celle affichée. Mesures gardées d'une fiche à l'autre
   (localStorage, facultatif). Couleur : teinte pleine de la fiche (data-teintes), sinon la photo de la pastille. */
(function () {
  var dlg = document.querySelector('[data-vs-tm]');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  var formats = (dlg.getAttribute('data-formats') || '').split(';').filter(Boolean).map(function (s) {
    var p = s.split('|'), a = parseFloat(p[1]), b = parseFloat(p[2]);
    return { valeur: p[0], court: Math.min(a, b), long: Math.max(a, b) };
  }).filter(function (f) { return f.long > 0; }).sort(function (a, b) { return a.long - b.long || a.court - b.court; });
  /* plaid bébé (plus grand format sous 120 cm) : ni canapé ni lit adulte, seul l'accordéon des repères reste */
  if (!formats.length || formats[formats.length - 1].long < 120) return;

  var posTaille = (parseInt(dlg.getAttribute('data-taille-pos'), 10) || 1) - 1;
  var variantes = (dlg.getAttribute('data-variantes') || '').split('¶').filter(Boolean).map(function (l) {
    var p = l.split('§');
    return { opts: p[0].split('¦'), prix: (p[1] || '').replace(/<[^>]*>/g, '').trim(), dispo: p[2] === 'true', id: p[3] };
  });
  var LITS = [{ l: 90, L: 190 }, { l: 140, L: 190 }, { l: 160, L: 200 }, { l: 180, L: 200 }];
  var C = { dessus: 20, face: 41, assise: 55, devantMax: 34, acc: 19, hAssise: 45, hDossier: 86, hCoude: 63, hPied: 11 };
  var OREILLERS = 45, PIED_MAX = 50;
  var mode = dlg.getAttribute('data-mode') === 'canape' ? 'canape' : 'lit';
  var longueur = 220, lit = LITS[1], taille = 170, couleur = '#8f7a6a', choix = null, retour = null;
  try {
    var mem = JSON.parse(localStorage.getItem('vs-taille') || 'null');
    if (mem && mem.longueur >= 120 && mem.longueur <= 360) longueur = mem.longueur;
    if (mem && LITS[mem.lit]) lit = LITS[mem.lit];
    if (mem && mem.taille >= 140 && mem.taille <= 200) taille = mem.taille;
  } catch (e) { /* stockage indisponible : réglages par défaut */ }
  /* passe 13 (02/11) : tant que le client n'a rien réglé (mesures gardées ou support choisi dans le studio), le verdict de la
     fiche se tait quand il est « court » : sur un plaid de 70 x 100, « Sur un lit de 140 x 190 cm : plus étroit que le lit »
     en rouge jugeait un usage que le client n'avait pas choisi (jury du 02/11, fiche plaid-carreaux) */
  var perso = !!mem;
  function memoriser() { perso = true; try { localStorage.setItem('vs-taille', JSON.stringify({ longueur: longueur, lit: LITS.indexOf(lit), taille: taille })); } catch (e) {} }
  var teintes = {};
  (dlg.getAttribute('data-teintes') || '').split('|').forEach(function (e) {
    var i = e.lastIndexOf('=');
    if (i > 0) teintes[e.slice(0, i)] = e.slice(i + 1);
  });

  var $ = function (s) { return dlg.querySelector(s); };
  var modes = $('.vsm__modes'), dessin = $('[data-vs-tm-dessin]'), verdict = $('[data-vs-tm-verdict]'), liste = $('[data-vs-tm-liste]');
  var choixTexte = $('[data-vs-tm-choix]'), ajouter = $('[data-vs-tm-ajouter]'), ajouterTexte = $('[data-vs-tm-ajouter-texte]'), prix = $('[data-vs-tm-prix]');
  var repli = $('[data-vsm-repli]'), resume = $('[data-vsm-resume]');
  var hote3d = $('[data-vsm-3d]'), attente = $('[data-vsm-attente]'), vues = $('[data-vsm-vues]'), geste = $('[data-vsm-geste]');
  var curseurs = { canape: $('[data-vsm-curseur="canape"]'), moi: $('[data-vsm-curseur="moi"]') };
  var sorties = { canape: $('[data-vsm-valeur="canape"]'), moi: $('[data-vsm-valeur="moi"]') };
  var matiere = dlg.getAttribute('data-matiere') || 'polaire', motifP = dlg.getAttribute('data-motif') || 'uni';
  var maxLong = formats[formats.length - 1].long;

  var r = Math.round;
  function cm(n) { return r(n) + ' cm'; }      /* espace insécable : jamais « 40 » et « cm » sur deux lignes */
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function brut(f) { return f.valeur.replace(/\s*[x×]\s*/i, ' x ').replace(/\s*cm\s*$/i, ' cm'); }
  function nom(f) { return esc(brut(f)); }

  /* ---------- Modèles ---------- */
  function surCanape(f) {
    var cotes = (f.long - longueur) / 2;
    var devant = Math.max(0, Math.min(f.court - (C.dessus + C.face + C.assise), C.devantMax));
    return { cotes: cotes, devant: devant, etat: cotes < -15 ? 'court' : cotes < 0 ? 'juste' : cotes <= 30 ? 'ideal' : 'long' };
  }
  function surLit(f) {
    var b = lit;
    if (f.court - b.l >= 30 && f.long >= b.L - OREILLERS) {
      var debut = OREILLERS, pied = f.long - (b.L - OREILLERS);
      if (pied > PIED_MAX) { pied = PIED_MAX; debut = b.L + PIED_MAX - f.long; }
      var trop = debut < 0;                                   /* plus long que le lit et sa retombée : il traîne au sol */
      if (trop) { debut = 0; pied = f.long - b.L; }
      var c = (f.court - b.l) / 2;
      return { pose: 'tout', cotes: c, pied: pied, debut: debut, trop: trop, etat: c > 55 || trop ? 'long' : 'ideal' };
    }
    var cj = (f.long - b.l) / 2;
    return { pose: 'pied', cotes: cj, profondeur: Math.min(f.court, b.L), etat: cj < 0 ? 'court' : cj < 15 ? 'juste' : cj <= 55 ? 'ideal' : 'long' };
  }
  function surMoi(f) {
    var ep = 0.82 * taille, bas = ep - f.court, tour = 0.62 * taille;
    var jusque = bas <= -12 ? 'sol' : bas <= 0.06 * taille ? 'pieds' : bas <= 0.2 * taille ? 'mollets' : bas <= 0.33 * taille ? 'genoux' : bas <= 0.5 * taille ? 'cuisses' : 'taille';
    var autour = f.long >= tour * 1.3 ? 'croise' : f.long >= tour ? 'tour' : 'dos';
    var bon = jusque === 'pieds' || jusque === 'mollets';
    var etat = jusque === 'sol' ? 'long' : bon && autour !== 'dos' ? 'ideal' : bon || jusque === 'genoux' ? 'juste' : 'court';
    return { jusque: jusque, autour: autour, bas: bas, etat: etat, cotes: bon ? 1 : -1, croise: f.long - tour };
  }
  function modele(f) { return mode === 'canape' ? surCanape(f) : mode === 'moi' ? surMoi(f) : surLit(f); }
  function conseille() {
    var m = formats.map(function (f) { return { f: f, m: modele(f) }; });
    var x = m.filter(function (y) { return y.m.etat === 'ideal' && y.m.pose !== 'pied'; })[0]
      || m.filter(function (y) { return y.m.etat === 'ideal'; })[0];
    if (x) return x.f;
    /* aucun format ne va : le plus proche de l'idéal (écart en cm), pas le plus grand */
    var ecart = function (y) {
      var g = y.m;
      if (mode === 'canape') return Math.abs(g.cotes - 15);
      if (mode === 'moi') return Math.abs(g.bas - 0.12 * taille) + (g.autour === 'dos' ? 40 : 0);
      return g.pose === 'tout' ? Math.abs(g.cotes - 30) + (g.trop ? g.pied : 0) : Math.abs(g.cotes - 30) + 60;
    };
    return m.slice().sort(function (a, b) { return ecart(a) - ecart(b); })[0].f;
  }
  var JUSQUE = { sol: 'jusqu’au sol', pieds: 'jusqu’aux pieds', mollets: 'jusqu’aux mollets', genoux: 'jusqu’aux genoux', cuisses: 'jusqu’à mi-cuisse', taille: 'jusqu’à la taille' };
  var AUTOUR = { croise: 'il vous enveloppe et croise devant', tour: 'il fait le tour des épaules', dos: 'il couvre le dos et les épaules sans fermer devant' };
  function phrase(f, m) {
    if (mode === 'moi') return 'Sur les épaules, il descend ' + JUSQUE[m.jusque] + (m.jusque === 'sol' ? ', où il traîne de ' + cm(-m.bas) : '') + ' ; ' + AUTOUR[m.autour] + (m.autour === 'croise' ? ' de ' + cm(m.croise) : '') + '.';
    if (mode === 'canape') {
      var dv = m.devant > 0 ? ' et de ' + cm(m.devant) + ' devant l’assise' : '';
      if (m.etat === 'court') return 'Il couvre ' + cm(f.long) + ' sur ' + cm(longueur) + ' : assez pour se glisser dessous, pas pour habiller tout le canapé.';
      if (m.etat === 'juste') return 'Un peu juste : les accoudoirs restent découverts de ' + cm(-m.cotes) + ' de chaque côté.';
      if (m.cotes < 3) return 'Il couvre le canapé d’un accoudoir à l’autre' + dv + '.';
      if (m.cotes >= C.hCoude - 5) return 'Il couvre tout le canapé et retombe jusqu’au sol de chaque côté' + (m.devant > 0 ? ', et de ' + cm(m.devant) + ' devant l’assise.' : '.');
      return 'Il couvre tout le canapé : il retombe de ' + cm(m.cotes) + ' sur chaque accoudoir' + dv + '.';
    }
    if (m.pose === 'tout' && m.trop) return 'Il couvre tout le lit, oreillers compris, et traîne au sol au pied du lit : un format pensé pour le canapé.';
    if (m.pose === 'tout') return 'Il couvre tout le lit : il retombe de ' + cm(m.cotes) + ' de chaque côté' + (m.pied > 0 ? ' et de ' + cm(m.pied) + ' au pied du lit.' : '.');
    if (m.etat === 'court') return 'Plus étroit que le lit (' + cm(f.long) + ' pour ' + cm(lit.l) + ') : un plaid pour les genoux, le fauteuil ou la sieste.';
    if (m.etat === 'juste') return 'En travers du pied de lit, il dépasse de ' + cm(m.cotes) + ' de chaque côté : posé à plat, il ne retombe presque pas.';
    return 'En travers du pied de lit, il retombe de ' + cm(m.cotes) + ' de chaque côté et couvre ' + cm(m.profondeur) + ' de la longueur du lit.';
  }
  /* mentions de la liste : courtes (une ligne) et chiffrées, pour que ce qui change d'un format à l'autre se lise */
  function etiquette(m) {
    if (mode === 'moi') {
      var bas = m.jusque === 'sol' ? 'traîne ' + r(-m.bas) + '\u00a0cm' : { pieds: 'aux pieds', mollets: 'aux mollets', genoux: 'aux genoux', cuisses: 'mi-cuisse', taille: 'à la taille' }[m.jusque];
      return bas + ' · ' + (m.autour === 'croise' ? 'croise ' + r(m.croise) + '\u00a0cm' : m.autour === 'tour' ? 'fait le tour' : 'ne ferme pas');
    }
    if (mode === 'canape') return { court: 'trop court', juste: 'un peu juste', ideal: m.cotes < 3 ? 'pile la longueur' : '+' + r(m.cotes) + '\u00a0cm par côté', long: '+' + r(m.cotes) + '\u00a0cm par côté' }[m.etat];
    if (m.pose === 'tout' && m.trop) { var tr = r(m.pied - 52); return tr > 2 ? 'traîne ' + tr + '\u00a0cm au sol' : 'touche le sol au pied'; }
    if (m.pose === 'tout') return 'couvre le lit, +' + r(m.cotes) + '\u00a0cm';
    return { court: 'plus étroit que le lit', juste: 'en travers, à plat', ideal: 'en travers, +' + r(m.cotes) + '\u00a0cm', long: 'en travers, +' + r(m.cotes) + '\u00a0cm' }[m.etat];
  }

  /* ---------- Dessin : la langue de l'accueil (« La bonne taille, à l'échelle ») : meubles au trait, plaid en aplat
     dans sa couleur, cotes à talons. Fait à la largeur réelle du cadre (textes en vrais pixels). ---------- */
  function nuance(hex, k) {
    var n = parseInt(hex.slice(1), 16), c = [n >> 16, (n >> 8) & 255, n & 255];
    return '#' + c.map(function (v) {
      var w = Math.max(0, Math.min(255, r(k >= 1 ? v + (255 - v) * (k - 1) : v * k)));
      return ('0' + w.toString(16)).slice(-2);
    }).join('');
  }
  function clarte(hex) {
    var n = parseInt(hex.slice(1), 16);
    return (0.2126 * (n >> 16) + 0.7152 * ((n >> 8) & 255) + 0.0722 * (n & 255)) / 255;
  }
  function n1(v) { return (Math.round(v * 10) / 10).toString(); }
  function rect(x, y, w, h, a) {
    return '<rect x="' + n1(x) + '" y="' + n1(y) + '" width="' + n1(Math.max(0, w)) + '" height="' + n1(Math.max(0, h)) + '"' + (a || '') + '/>';
  }
  function texte(x, y, t, cls, ancre) {
    return '<text x="' + n1(x) + '" y="' + n1(y) + '"' + (ancre ? ' text-anchor="' + ancre + '"' : '') + ' class="' + cls + '">' + t + '</text>';
  }
  function cote(x1, x2, y, t, plaid, dessous) {
    return '<path d="M' + n1(x1) + ',' + n1(y - 5) + 'v10M' + n1(x1) + ',' + n1(y) + 'H' + n1(x2) + 'M' + n1(x2) + ',' + n1(y - 5) + 'v10" class="vs-c-ligne' + (plaid ? ' vs-c-ligne--plaid' : '') + '"/>'
      + texte((x1 + x2) / 2, dessous ? y + 18 : y - 9, t, 'vs-c-legende' + (plaid ? ' vs-c-legende--plaid' : ''), 'middle');
  }
  /* ce qui retombe (passe 11 : la légende « posé, retombe » est retirée, deux bruns voisins ne se distinguaient pas) :
     la même couleur mêlée au papier, nettement plus claire ; un plaid déjà très clair passe plus foncé */
  function melange(hex, vers, t) {
    var a = parseInt(hex.slice(1), 16), b = parseInt(vers.slice(1), 16), o = '#';
    [16, 8, 0].forEach(function (d) { var c = Math.round(((a >> d) & 255) * (1 - t) + ((b >> d) & 255) * t); o += (c < 16 ? '0' : '') + c.toString(16); });
    return o;
  }
  function ombreDe(hex) { return clarte(hex) > 0.72 ? nuance(hex, 0.78) : melange(hex, '#f6f5f3', 0.58); }
  function peinture() {
    return {
      fond: couleur, ombre: ombreDe(couleur),
      trait: ' stroke="' + (clarte(couleur) > 0.8 ? '#9b9086' : nuance(couleur, 0.7)) + '" stroke-width="1"',
      defs: ''
    };
  }
  function ouvrir(w, h, p) {
    return '<svg width="' + w + '" height="' + h + '" viewBox="0 0 ' + w + ' ' + h + '" class="vs-tm__svg" focusable="false">' + p.defs;
  }

  /* ---------- Plan coté (passe 14, 04/11/2026) ----------
     Deux vues d'architecte sur une planche, à la même échelle : l'élévation (meubles au trait, pleins) et la coupe
     (hachurée), le plaid en aplat ou en trait épais dans sa couleur, les cotes à talons. Les chiffres sont ceux du
     modèle du verdict. Canapé : de face et de côté ; lit : de dessus et en travers ; moi : de face et autour des épaules,
     vu d'en haut. Vue « Plan coté » du studio, et repli sans WebGL (le mode « Moi » y est désormais). */
  var EP = 2, etroitPlan = false;                          /* le plaid est dessiné à 2 cm de ce qu'il couvre */
  function coteV(x, y1, y2, t, ancre) {                    /* cote verticale, texte à côté, à mi-hauteur */
    return '<path d="M' + n1(x - 5) + ',' + n1(y1) + 'h10M' + n1(x) + ',' + n1(y1) + 'V' + n1(y2) + 'M' + n1(x - 5) + ',' + n1(y2) + 'h10" class="vs-c-ligne vs-c-ligne--plaid"/>'
      + texte(ancre === 'end' ? x - 9 : x + 9, (y1 + y2) / 2 + 4, t, 'vs-c-cote', ancre || 'start');
  }
  function legendeVue(x, y, t, detail) {
    return '<text x="' + n1(x) + '" y="' + n1(y) + '" class="vs-c-vue">' + t + (detail && !etroitPlan ? '<tspan class="vs-c-vue-detail"> · ' + detail + '</tspan>' : '') + '</text>';
  }
  function trace(pts, p, ep) {                             /* le plaid vu en coupe : trait épais, liseré si clair */
    var d = 'M' + pts.map(function (q) { return n1(q[0]) + ',' + n1(q[1]); }).join('L');
    return '<path d="' + d + '" class="vs-c-plaid-trait vs-c-plaid-trait--bord" stroke-width="' + n1(ep + 2) + '" stroke="' + (clarte(couleur) > 0.8 ? '#9b9086' : nuance(couleur, 0.7)) + '"/>'
      + '<path d="' + d + '" class="vs-c-plaid-trait" stroke-width="' + n1(ep) + '" stroke="' + couleur + '"/>';
  }
  function hachure() {
    return '<defs><pattern id="vs-hachure" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">'
      + '<rect width="6" height="6" fill="#f6f2ec"/><line x1="0" y1="0" x2="0" y2="6" stroke="#cdc3b7" stroke-width="1.2"/></pattern></defs>';
  }
  /* les vues côte à côte, une échelle commune, bas alignés (le sol) : v = { l, h } en cm, ml, mr, mt, mb en px */
  function planche(w, h, vs, gx) {
    var fixe = gx * (vs.length - 1), cmL = 0;
    vs.forEach(function (v) { fixe += v.ml + v.mr; cmL += v.l; });
    var k = Math.min((w - fixe) / cmL, Math.min.apply(null, vs.map(function (v) { return (h - v.mt - v.mb) / v.h; })));
    k = Math.max(k, 0.2);
    var haut = Math.max.apply(null, vs.map(function (v) { return v.mt + v.h * k + v.mb; }));
    var large = fixe + cmL * k, x = (w - large) / 2, y0 = (h - haut) / 2;
    vs.forEach(function (v) {
      v.ox = x + v.ml; v.sol = y0 + haut - v.mb; v.haut = y0; v.k = k;
      v.X = function (c) { return v.ox + c * k; }; v.Y = function (z) { return v.sol - z * k; };
      x += v.ml + v.l * k + v.mr + gx;
    });
    return k;
  }

  function planCanape(f, w, h) {
    var L = longueur, m = surCanape(f), p = peinture(), etroit = w < 560;
    var dessus = C.dessus, prof = C.dessus + C.assise, reste = f.court - (C.dessus + C.face + C.assise);
    var devant = m.devant, derriere = Math.max(0, reste - C.devantMax);
    var bord = m.cotes > 0 ? 6 : 0, lab = etroit ? 62 : 72;
    var face = { l: L + 2 * bord, h: C.hDossier + 6, ml: m.cotes > 0 ? lab : 6, mr: m.cotes > 0 ? lab : 6, mt: 46, mb: 40 };
    var cote2 = { l: prof + 2 * EP, h: C.hDossier + 6, ml: derriere > 1 ? lab : 6, mr: devant > 0 ? lab : 6, mt: 46, mb: 40 };
    planche(w, h, [face, cote2], etroit ? 22 : 56);
    var k = face.k, s = ouvrir(w, h, p) + hachure();
    s += '<line x1="12" x2="' + (w - 12) + '" y1="' + n1(face.sol) + '" y2="' + n1(face.sol) + '" class="vs-c-sol"/>';

    /* de face : le canapé, le plaid sur le dossier et l'assise, ce qui passe sur les accoudoirs et retombe */
    var X = function (c) { return face.X(c + bord); }, Y = face.Y;
    s += rect(X(8), Y(C.hPied), 4 * k, C.hPied * k, ' class="vs-c-pied"') + rect(X(L - 12), Y(C.hPied), 4 * k, C.hPied * k, ' class="vs-c-pied"');
    s += rect(X(C.acc - 4), Y(C.hDossier), (L - 2 * C.acc + 8) * k, (C.hDossier - C.hAssise + 6) * k, ' rx="' + n1(7 * k) + '" class="vs-c-meuble"');
    s += rect(X(0), Y(C.hAssise), L * k, (C.hAssise - C.hPied) * k, ' rx="' + n1(5 * k) + '" class="vs-c-meuble"');
    var places = L >= 230 ? 3 : L >= 160 ? 2 : 1, lp = (L - 2 * C.acc) / places;
    for (var i = 1; i < places; i++) s += '<line x1="' + n1(X(C.acc + i * lp)) + '" x2="' + n1(X(C.acc + i * lp)) + '" y1="' + n1(Y(C.hAssise - 1)) + '" y2="' + n1(Y(26)) + '" class="vs-c-couture"/>';
    s += rect(X(0), Y(C.hCoude), C.acc * k, (C.hCoude - C.hPied) * k, ' rx="' + n1(7 * k) + '" class="vs-c-meuble"');
    s += rect(X(L - C.acc), Y(C.hCoude), C.acc * k, (C.hCoude - C.hPied) * k, ' rx="' + n1(7 * k) + '" class="vs-c-meuble"');
    var aplat = function (x, y, ww, hh, ombre, rx) { return rect(x, y, ww, hh, ' rx="' + n1(rx || 0) + '" fill="' + (ombre ? p.ombre : p.fond) + '"' + p.trait + ' class="vs-c-plaid"'); };
    var xa = (L - f.long) / 2, xb = xa + f.long, ia = Math.max(xa, C.acc), ib = Math.min(xb, L - C.acc);
    if (ib > ia) {
      s += aplat(X(ia), Y(C.hDossier + 1.5), (ib - ia) * k, (C.hDossier + 1.5 - C.hAssise) * k, false, 5 * k);
      if (devant > 0) s += aplat(X(ia), Y(C.hAssise), (ib - ia) * k, devant * k, true, 3 * k);
    }
    [1, -1].forEach(function (sens) {
      if (!(sens > 0 ? xa < C.acc : xb > L - C.acc)) return;
      var a1 = sens > 0 ? Math.max(xa, 0) : L - C.acc, a2 = sens > 0 ? C.acc : Math.min(xb, L);
      s += aplat(X(a1), Y(C.hCoude + 1.5), (a2 - a1) * k, 6 * k, false, 3 * k);
      if (m.cotes > 0) {
        var chute = Math.min(m.cotes, C.hCoude - 3);
        s += aplat(sens > 0 ? X(-5) : X(L), Y(C.hCoude + 1.5), 5 * k, (chute + 1.5) * k, true, 2 * k);
        s += coteV(sens > 0 ? X(-5) - 10 : X(L + 5) + 10, Y(C.hCoude + 1.5), Y(C.hCoude - chute), '+' + cm(m.cotes), sens > 0 ? 'end' : 'start');
      }
    });
    s += cote(X(xa), X(xb), Y(C.hDossier) - 16, cm(f.long), true);
    s += cote(X(0), X(L), face.sol + 14, 'Canapé ' + cm(L), false, true);
    s += legendeVue(face.ox, face.haut + 12, 'De face', cm(f.long) + ' dans la longueur');

    /* de côté, en coupe : dos, dessus du dossier, face du dossier, assise ; le plaid suit ce profil sur son petit côté */
    var U = cote2.X, V = cote2.Y, u = function (c) { return U(c + EP); };
    var r1 = 6;
    var prof2 = 'M' + n1(u(0)) + ',' + n1(V(C.hPied)) + 'V' + n1(V(C.hDossier - r1)) + 'Q' + n1(u(0)) + ',' + n1(V(C.hDossier)) + ' ' + n1(u(r1)) + ',' + n1(V(C.hDossier))
      + 'H' + n1(u(dessus - r1)) + 'Q' + n1(u(dessus)) + ',' + n1(V(C.hDossier)) + ' ' + n1(u(dessus)) + ',' + n1(V(C.hDossier - r1))
      + 'V' + n1(V(C.hAssise)) + 'H' + n1(u(prof - 4)) + 'Q' + n1(u(prof)) + ',' + n1(V(C.hAssise)) + ' ' + n1(u(prof)) + ',' + n1(V(C.hAssise - 4))
      + 'V' + n1(V(C.hPied)) + 'Z';
    s += '<path d="' + prof2 + '" fill="url(#vs-hachure)" class="vs-c-coupe"/>';
    s += rect(u(5), V(C.hPied), 3 * k, C.hPied * k, ' class="vs-c-pied"') + rect(u(prof - 8), V(C.hPied), 3 * k, C.hPied * k, ' class="vs-c-pied"');
    /* le trajet du plaid, longueur par longueur (derrière, dessus, face, assise, devant) */
    var budget = f.court - derriere, pts = [];
    var zH = C.hDossier + EP, zA = C.hAssise + EP;
    if (derriere > 0) pts.push([u(-EP), V(Math.max(EP, zH - derriere))]);
    pts.push([u(-EP), V(zH)]);
    var pas = function (lg, a, b) { var t = Math.max(0, Math.min(1, budget / lg)); budget -= lg; pts.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]); return t >= 1; };
    var ok = pas(dessus + EP, [u(-EP), V(zH)], [u(dessus + EP), V(zH)])
      && pas(C.face, [u(dessus + EP), V(zH)], [u(dessus + EP), V(zA)])
      && pas(C.assise, [u(dessus + EP), V(zA)], [u(prof + EP), V(zA)]);
    if (ok && devant > 0) pts.push([u(prof + EP), V(zA - devant)]);
    s += trace(pts, p, Math.max(3, Math.min(5, 2.2 * k)));
    if (devant > 0) s += coteV(u(prof + EP) + 12, V(zA), V(zA - devant), cm(devant), 'start');
    else if (!ok) s += texte(pts[pts.length - 1][0], V(zA) - 12, 's’arrête sur l’assise', 'vs-c-cote', 'middle');
    if (derriere > 1) s += coteV(u(-EP) - 12, V(zH), V(Math.max(EP, zH - derriere)), cm(derriere), 'end');
    s += legendeVue(cote2.ox, cote2.haut + 12, 'De côté', cm(f.court) + ' sur le dossier et l’assise');
    return s + '</svg>';
  }

  function planLit(f, w, h) {
    var b = lit, m = surLit(f), p = peinture(), etroit = w < 560;
    var HL = 52, HC = 30;                                  /* hauteur du lit (cadre et matelas), comme la scène */
    var d = Math.max(m.cotes, 0), pied = m.pose === 'tout' ? Math.min(m.pied, 60) : 0;
    var lab = etroit ? 68 : 80;
    var dessus = { l: b.L + 8 + pied + 4, h: b.l + 2 * d, ml: 6, mr: m.pose === 'tout' && m.pied > 0 ? lab + 14 : 6, mt: 46, mb: 40 };
    var chute = Math.min(d, HL), sol = Math.max(0, d - HL);
    var travers = { l: b.l + 2 * (chute + sol + EP), h: HL + 6, ml: 6, mr: d > 0 ? lab : 6, mt: 46, mb: 40 };
    planche(w, h, [dessus, travers], etroit ? 22 : 56);
    var k = dessus.k, s = ouvrir(w, h, p) + hachure();

    /* vu de dessus, tête à gauche (le haut de la vue est centré sur le lit) */
    var U = function (c) { return dessus.X(c + 8); };
    var V0 = dessus.Y(dessus.h) , V = function (v) { return V0 + (v + d) * k; };
    s += rect(U(-8), V(-4), 8 * k, (b.l + 8) * k, ' rx="' + n1(2 * k) + '" class="vs-c-tete"');
    s += rect(U(0), V(0), b.L * k, b.l * k, ' rx="' + n1(4 * k) + '" class="vs-c-meuble"');
    var u1, u2, v1, v2;
    if (m.pose === 'tout') { u1 = m.debut; u2 = b.L + pied; v1 = -m.cotes; v2 = b.l + m.cotes; }
    else { u1 = b.L - m.profondeur; u2 = b.L; v1 = (b.l - f.long) / 2; v2 = v1 + f.long; }
    s += rect(U(u1), V(v1), (u2 - u1) * k, (v2 - v1) * k, ' rx="' + n1(2 * k) + '" fill="' + p.ombre + '"' + p.trait + ' class="vs-c-plaid"');
    var a1 = Math.max(u1, 0), a2 = Math.min(u2, b.L), c1 = Math.max(v1, 0), c2 = Math.min(v2, b.l);
    s += rect(U(a1), V(c1), (a2 - a1) * k, (c2 - c1) * k, ' fill="' + p.fond + '" class="vs-c-plaid"');
    if (v1 < 0 || u2 > b.L || v2 > b.l) s += rect(U(0), V(0), b.L * k, b.l * k, ' rx="' + n1(4 * k) + '" class="vs-c-bord"');
    var n = b.l >= 140 ? 2 : 1, marge = 8, ecart = 8, larg = (b.l - 2 * marge - (n - 1) * ecart) / n;
    for (var i = 0; i < n; i++) s += rect(U(5), V(marge + i * (larg + ecart)), 36 * k, larg * k, ' rx="' + n1(7 * k) + '" class="vs-c-oreiller"');
    if (m.pose === 'tout' && m.pied > 0) s += coteV(U(b.L + pied) + 12, V(b.l / 2 - 14), V(b.l / 2 + 14), m.trop ? 'au sol' : cm(m.pied) + ' au pied', 'start').replace(/<path[^>]*\/>/, '');
    s += cote(U(0), U(b.L), dessus.sol + 14, 'Lit ' + b.l + ' x ' + cm(b.L), false, true);
    s += legendeVue(dessus.ox, dessus.haut + 12, 'Vu de dessus', (m.pose === 'tout' ? cm(f.long) : cm(m.profondeur)) + ' dans la longueur');

    /* en travers, en coupe : cadre et matelas ; le plaid sur le dessus et ce qui retombe de chaque côté */
    var X = function (c) { return travers.X(c + chute + sol + EP); }, Y = travers.Y;
    s += '<line x1="' + n1(travers.ox - 4) + '" x2="' + n1(travers.ox + travers.l * k + 4) + '" y1="' + n1(travers.sol) + '" y2="' + n1(travers.sol) + '" class="vs-c-sol"/>';
    s += rect(X(4), Y(HC), (b.l - 8) * k, (HC - 6) * k, ' class="vs-c-meuble"');
    s += rect(X(6), Y(6), 4 * k, 6 * k, ' class="vs-c-pied"') + rect(X(b.l - 10), Y(6), 4 * k, 6 * k, ' class="vs-c-pied"');
    s += '<rect x="' + n1(X(0)) + '" y="' + n1(Y(HL)) + '" width="' + n1(b.l * k) + '" height="' + n1((HL - HC) * k) + '" rx="' + n1(5 * k) + '" fill="url(#vs-hachure)" class="vs-c-coupe"/>';
    var zH = HL + EP, pts;
    if (m.cotes >= 0) {
      pts = [[X(-EP), Y(zH)], [X(b.l + EP), Y(zH)]];
      var g = [[X(-EP), Y(Math.max(EP, zH - chute))]], dr = [[X(b.l + EP), Y(Math.max(EP, zH - chute))]];
      if (sol > 0) { g.push([X(-EP - sol), Y(EP)]); dr.push([X(b.l + EP + sol), Y(EP)]); }
      pts = g.reverse().concat(pts).concat(dr);
    } else pts = [[X(-m.cotes), Y(zH)], [X(b.l + m.cotes), Y(zH)]];
    s += trace(pts, p, Math.max(3, Math.min(5, 2.2 * k)));
    if (m.cotes > 1) s += coteV(X(b.l + EP + sol) + 12, Y(zH), Y(Math.max(EP, zH - chute)), (sol > 0 ? 'au sol, ' : '') + '+' + cm(m.cotes), 'start');
    else if (m.cotes < 0) s += texte(X(b.l / 2), Y(zH) - 12, cm(-m.cotes) + ' de moins que le lit de chaque côté', 'vs-c-cote', 'middle');
    s += cote(X(0), X(b.l), travers.sol + 14, cm(b.l) + ' de large', false, true);
    s += legendeVue(travers.ox, travers.haut + 12, 'En travers', cm(m.pose === 'tout' ? f.court : f.long) + ' dans la largeur');
    return s + '</svg>';
  }

  function planMoi(f, w, h) {
    var H = taille, m = surMoi(f), p = peinture(), etroit = w < 560;
    var ep = 0.82 * H, tour = 0.62 * H, lE = 0.135 * H, lab = etroit ? 74 : 96;
    var face = { l: 2 * lE + 8, h: H + 2, ml: 52, mr: lab, mt: 46, mb: 26 };
    var rx = 0.15 * H, ry = 0.085 * H, dessus = { l: 2 * rx + 14, h: 2 * ry + 14, ml: 10, mr: 10, mt: 46, mb: 26 };
    planche(w, h, [face, dessus], etroit ? 18 : 48);
    var k = face.k, s = ouvrir(w, h, p) + hachure();
    var X = function (c) { return face.X(c + lE + 4); }, Y = face.Y;
    s += '<line x1="' + n1(face.ox - 6) + '" x2="' + n1(face.ox + face.l * k + 6) + '" y1="' + n1(face.sol) + '" y2="' + n1(face.sol) + '" class="vs-c-sol"/>';
    /* la figurine, de face */
    var t = 0.062 * H, ep2 = 0.112 * H, han = 0.08 * H, jb = 0.032 * H, br = 0.028 * H;
    s += '<circle cx="' + n1(X(0)) + '" cy="' + n1(Y(H - t)) + '" r="' + n1(t * k) + '" class="vs-c-meuble"/>';
    s += rect(X(-ep2), Y(ep), 2 * ep2 * k, (ep - 0.5 * H) * k, ' rx="' + n1(0.035 * H * k) + '" class="vs-c-meuble"');
    [-1, 1].forEach(function (c) {
      s += rect(X(c * (0.045 * H) - jb), Y(0.51 * H), 2 * jb * k, 0.51 * H * k, ' rx="' + n1(jb * k) + '" class="vs-c-meuble"');
      s += rect(X(c * (ep2 + br * 0.6) - br), Y(ep - 0.02 * H), 2 * br * k, (ep - 0.02 * H - 0.44 * H) * k, ' rx="' + n1(br * k) + '" class="vs-c-meuble"');
    });
    /* le châle, en cape : chaque pan part du cou, passe sur l'épaule et le bras, descend en s'évasant un peu ; les deux
       bords intérieurs se croisent (« croise »), se touchent ou laissent un V ouvert, selon la part du devant couverte */
    var haut = ep + EP, bas = Math.max(EP, m.bas), demi = tour / 2;
    var nk = 0.036 * H, cou = ep + 0.03 * H, xo = ep2 + 1.6 * br, ev = 0.012 * H, ro = 0.03 * H, xb = xo + ev;
    var couvre = Math.max(0.3, Math.min(1.55, (f.long - demi) / demi));     /* 1 : les pans se touchent au milieu */
    var pan = function (c) {                                 /* c = -1 : pan gauche ; +1 : pan droit, posé dessus */
      xi = c * xb - c * xb * couvre;                          /* bord intérieur, en bas */
      return 'M' + n1(X(c * nk)) + ',' + n1(Y(cou)) + 'L' + n1(X(c * (xo - ro))) + ',' + n1(Y(haut))
        + 'Q' + n1(X(c * xo)) + ',' + n1(Y(haut)) + ' ' + n1(X(c * xo)) + ',' + n1(Y(haut - ro))
        + 'L' + n1(X(c * xb)) + ',' + n1(Y(bas)) + 'L' + n1(X(xi)) + ',' + n1(Y(bas)) + 'Z';
    };
    s += '<path d="' + pan(-1) + '" fill="' + p.fond + '"' + p.trait + ' stroke-linejoin="round" class="vs-c-plaid"/>';
    s += '<path d="' + pan(1) + '" fill="' + p.fond + '"' + p.trait + ' stroke-linejoin="round" class="vs-c-plaid"/>';
    s += coteV(face.ox - 14, Y(H), Y(0), cm(H), 'end');
    if (m.bas > 1) s += coteV(X(lE) + 14, Y(bas), Y(0), 'à ' + cm(m.bas) + ' du sol', 'start');
    else if (m.bas < -1) s += texte(X(lE) + 10, Y(EP) - 4, 'traîne ' + cm(-m.bas), 'vs-c-cote', 'start');
    s += legendeVue(face.ox - 40, face.haut + 12, 'De face', cm(f.court) + ' des épaules vers le bas');

    /* autour des épaules, vu d'en haut (le devant en bas) : le grand côté part du milieu du dos, de chaque côté */
    var cx = dessus.X(dessus.l / 2), cy = Y(ep) - (dessus.sol - dessus.Y(dessus.h / 2)) * 0;
    cy = Math.max(dessus.haut + 24 + (ry + 7) * k, Math.min(dessus.sol - (ry + 7) * k, Y(ep)));
    s += '<line x1="' + n1(X(lE) + 4) + '" x2="' + n1(cx - (rx + 9) * k) + '" y1="' + n1(Y(ep)) + '" y2="' + n1(cy) + '" class="vs-c-bord"/>';
    s += '<ellipse cx="' + n1(cx) + '" cy="' + n1(cy) + '" rx="' + n1(rx * k) + '" ry="' + n1(ry * k) + '" fill="url(#vs-hachure)" class="vs-c-coupe"/>';
    s += '<circle cx="' + n1(cx) + '" cy="' + n1(cy) + '" r="' + n1(t * k) + '" class="vs-c-meuble"/>';
    var per = Math.PI * (3 * (rx + ry) - Math.sqrt((3 * rx + ry) * (rx + 3 * ry)));
    var arc = function (sens, debut, fin, off) {             /* morceau d'ellipse décalée de « off » cm, en longueur d'arc */
      var q = [], n = 40;
      for (var j = 0; j <= n; j++) {
        var a = (debut + (fin - debut) * j / n) / per * 2 * Math.PI;
        q.push([cx + sens * (rx + off) * Math.sin(a) * k, cy - (ry + off) * Math.cos(a) * k]);
      }
      return q;
    };
    var moitie = f.long / 2 * (per / tour), lim = per / 2, epT = Math.max(3, Math.min(5, 2.2 * k));
    [-1, 1].forEach(function (sens) {
      s += trace(arc(sens, 0, Math.min(moitie, lim), 3), p, epT);
      if (moitie > lim) s += trace(arc(-sens, lim, Math.min(per, lim + (moitie - lim)), sens > 0 ? 6.5 : 3), p, epT);
    });
    s += texte(cx, cy + (ry + 10) * k + 14, 'devant', 'vs-c-vue-detail', 'middle');
    var dit = m.autour === 'croise' ? 'croise de ' + cm(m.croise) : m.autour === 'tour' ? 'fait le tour' : 'ouvert de ' + cm(-m.croise);
    s += texte(cx, cy + (ry + 10) * k + 32, dit, 'vs-c-cote', 'middle');
    s += legendeVue(dessus.ox, dessus.haut + 12, 'Aux épaules', cm(f.long) + ' autour, vu d’en haut');
    return s + '</svg>';
  }
  function planSvg(f, w, h) { etroitPlan = w < 560; return mode === 'canape' ? planCanape(f, w, h) : mode === 'moi' ? planMoi(f, w, h) : planLit(f, w, h); }

  /* ---------- Variantes de la fiche (boutons de Honey) ---------- */
  function radiosTaille() {
    return Array.prototype.filter.call(document.querySelectorAll('variant-selects input[type="radio"]'), function (i) { return /^taille/i.test(i.name || ''); });
  }
  function formatFiche() {
    var x = radiosTaille().filter(function (i) { return i.checked; })[0];
    var v = x ? x.value : null;
    return formats.filter(function (f) { return f.valeur === v; })[0] || null;
  }
  function formatChoisi() {
    return (choix && formats.filter(function (f) { return f.valeur === choix; })[0]) || formatFiche() || formats[0];
  }
  function autresChoix() {
    var s = {}, noms = [];
    Array.prototype.forEach.call(document.querySelectorAll('variant-selects input[type="radio"]:checked'), function (i) {
      s[i.value] = 1;
      if (!/^taille/i.test(i.name || '')) noms.push(i.value);
    });
    Array.prototype.forEach.call(document.querySelectorAll('variant-selects select'), function (x) { if (x.value) s[x.value] = 1; });
    return { valeurs: s, noms: noms };
  }
  function variantePour(valeur) {
    var s = autresChoix().valeurs;
    return variantes.filter(function (v) {
      return v.opts[posTaille] === valeur && v.opts.every(function (o, j) { return j === posTaille || s[o]; });
    })[0] || null;
  }

  /* ---------- La scène 3D ---------- */
  var moteur = null, moteurEtat = 'rien', plan = false, aRegler = false;
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  function webgl() {
    try { var c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl'))); }
    catch (e) { return false; }
  }
  function basculer2d() {
    moteurEtat = 'echec';
    dlg.classList.add('is-2d'); dlg.classList.remove('is-3d');
    dessin.hidden = false; attente.hidden = true; vues.hidden = true; geste.hidden = true;
    rendre();
  }
  var precharge = false;
  function prechargerMoteur() {
    if (precharge || !dlg.getAttribute('data-moteur')) return;
    precharge = true;
    var l = document.createElement('link'); l.rel = 'preload'; l.as = 'script'; l.href = dlg.getAttribute('data-moteur');
    document.head.appendChild(l);
  }
  function chargerMoteur() {
    if (moteurEtat !== 'rien') return;
    if (!webgl() || !dlg.getAttribute('data-moteur')) return basculer2d();
    moteurEtat = 'charge';
    var fin = setTimeout(function () { if (moteurEtat === 'charge') basculer2d(); }, 15000);
    var demarrer = function () {
      clearTimeout(fin);
      if (moteurEtat !== 'charge') return;
      try {
        moteur = window.VSPlaid3D.creer(hote3d, {
          reduit: reduit.matches,
          surRepos: function () { dlg.classList.add('is-pose'); },
          surTourne: function () { geste.classList.add('is-vu'); }
        });
        moteurEtat = 'pret';
        dlg.classList.add('is-3d');
        vues.hidden = false; geste.hidden = false;
        rendre();
        setTimeout(function () { attente.hidden = true; }, 60);
      } catch (e) { basculer2d(); }
    };
    if (window.VSPlaid3D) return demarrer();
    var s = document.createElement('script');
    s.src = dlg.getAttribute('data-moteur'); s.async = true;
    s.onload = demarrer;
    s.onerror = function () { clearTimeout(fin); basculer2d(); };
    document.head.appendChild(s);
  }
  /* « Plan coté » (passe 14) : la planche remplace la scène, la scène reste chargée ; elle se recale au retour */
  function montrerPlan(oui) {
    plan = oui;
    dlg.classList.toggle('is-plan', oui);
    dessin.hidden = !oui && moteurEtat !== 'echec';
    if (oui) { dessiner(formatChoisi()); return; }
    if (aRegler && moteur) { aRegler = false; rendre(); }
  }
  function dessiner(f) {
    var cs = getComputedStyle(dessin);
    var w = dessin.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var h = dessin.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    if (w > 0 && h > 0) dessin.innerHTML = planSvg(f, w, h);
  }
  function etat3d(f, m) {
    var p = { couleur: couleur, matiere: matiere, motif: motifP, cx: 0, cz: 0 };
    var e = { mode: mode, textes: { plaid: 'Plaid ' + brut(f) }, debords: [], plaid: p };
    if (mode === 'canape') {
      e.cle = 'c' + longueur; e.canape = { L: longueur };
      p.wx = f.long; p.wz = f.court;
      e.textes.meuble = 'Canapé ' + cm(longueur);
      if (m.cotes > 2) e.debords = [{ cote: 'gauche', texte: '+' + cm(m.cotes), y: 48 }, { cote: 'droite', texte: '+' + cm(m.cotes), y: 48 }];
    } else if (mode === 'lit') {
      e.cle = 'l' + lit.l + 'x' + lit.L; e.lit = { l: lit.l, L: lit.L };
      e.textes.meuble = 'Lit ' + lit.l + ' x ' + cm(lit.L);
      if (m.pose === 'tout') { p.wx = f.court; p.wz = f.long; p.cz = -lit.L / 2 + m.debut + f.long / 2; }
      else { p.wx = f.long; p.wz = f.court; p.cz = lit.L / 2 - f.court / 2 + 3; }
      if (m.cotes > 2) e.debords = [{ cote: 'gauche', texte: '+' + cm(m.cotes), y: 34 }];
    } else {
      e.cle = 'm' + taille; e.moi = { h: taille };
      p.wx = f.long; p.wz = f.court;
      e.textes.meuble = cm(taille);
    }
    return e;
  }

  /* ---------- Rendu ---------- */
  function verdictCourt() {
    var court = document.querySelector('[data-vs-verdict-court]');
    if (!court) return;
    var f = formatChoisi(), m = modele(f);
    if (m.etat === 'court' && !perso) {           /* rien de réglé : pas de verdict négatif sur un usage supposé */
      if (!court.hidden) court.hidden = true;
      court.removeAttribute('data-sig');
      return;
    }
    var ou = mode === 'canape' ? 'Sur un canapé de ' + cm(longueur) : mode === 'moi' ? 'Sur vous (' + cm(taille) + ')' : 'Sur un lit de ' + lit.l + ' x ' + lit.L + '\u00a0cm';
    var html = '<span class="vs-vc__pastille" aria-hidden="true"></span><span class="vs-vc__texte">' + ou + ' : ' + esc(etiquette(m)) + '</span><span class="vs-vc__modifier">Voir en 3D</span>';
    var sig = m.etat + '|' + html;
    if (court.getAttribute('data-sig') === sig && !court.hidden) return;   /* sinon l'observateur de la fiche boucle */
    court.setAttribute('data-sig', sig);
    court.hidden = false;
    court.className = 'vs-vc vs-vc--' + m.etat;
    court.setAttribute('aria-haspopup', 'dialog');
    court.innerHTML = html;
  }
  function glyphe(g) {
    var w = Math.max(10, g.long / maxLong * 40), h = Math.max(7, g.court / maxLong * 40);
    return '<span class="vsm__glyphe" aria-hidden="true"><span style="width:' + w.toFixed(1) + 'px;height:' + h.toFixed(1) + 'px"></span></span>';
  }
  function rendre() {
    var f = formatChoisi(), m = modele(f), c = conseille();
    modes.setAttribute('data-actif', mode);
    dlg.setAttribute('data-mode-actif', mode);
    dlg.querySelectorAll('[data-vs-mode]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-vs-mode') === mode)); });
    dlg.querySelectorAll('[data-vs-reglage]').forEach(function (n) { n.hidden = n.getAttribute('data-vs-reglage') !== mode; });
    dlg.querySelectorAll('[data-vs-lit]').forEach(function (b) { b.setAttribute('aria-pressed', String(LITS[+b.getAttribute('data-vs-lit')] === lit)); });
    curseurs.canape.value = longueur; curseurs.moi.value = taille;
    curseurs.canape.style.setProperty('--vs-p', ((longueur - 120) / 240 * 100) + '%');
    curseurs.moi.style.setProperty('--vs-p', ((taille - 140) / 60 * 100) + '%');
    if (document.activeElement !== sorties.canape) sorties.canape.value = longueur;
    if (document.activeElement !== sorties.moi) sorties.moi.value = taille;
    dlg.style.setProperty('--vs-plaid', couleur);
    if (moteurEtat === 'pret' && plan) aRegler = true;    /* la scène cachée ne simule pas : elle se recale au retour */
    else if (moteurEtat === 'pret') {
      try { moteur.regler(etat3d(f, m)); } catch (e) { basculer2d(); return; }
    }
    if (moteurEtat === 'echec' || plan) dessiner(f);
    verdict.className = 'vsm__verdict vsm__verdict--' + m.etat;
    verdict.innerHTML = '<span class="vsm__pastille" aria-hidden="true"></span><span><strong>' + nom(f) + '</strong> ' + phrase(f, m) + '</span>';
    if (resume) resume.innerHTML = '<span>' + (mode === 'canape' ? 'Canapé de ' + cm(longueur) : mode === 'lit' ? 'Lit ' + lit.l + ' x ' + lit.L + '\u00a0cm' : 'Vous, ' + cm(taille)) + '</span><span class="vsm__resume-lien">Modifier</span>';
    var actif = document.activeElement, focusFormat = actif && dlg.contains(actif) ? actif.getAttribute('data-vs-format') : null;
    var unIdeal = formats.some(function (g) { return modele(g).etat === 'ideal'; });
    liste.innerHTML = formats.map(function (g) {
      var mg = modele(g), v = variantePour(g.valeur), conseil = g.valeur === c.valeur;
      return '<li><button type="button" class="vsm__format vsm__format--' + mg.etat + (v && !v.dispo ? ' is-epuise' : '') + '" data-vs-format="' + esc(g.valeur) + '" aria-pressed="' + (g.valeur === f.valeur) + '">'
        + glyphe(g)
        + '<span class="vsm__format-texte"><span class="vsm__format-nom">' + nom(g) + (conseil ? '<span class="vsm__badge' + (unIdeal ? '' : ' vsm__badge--proche') + '">' + (unIdeal ? 'Conseillé' : 'Plus proche') + '</span>' : '') + '</span>'
        + '<span class="vsm__format-etat"><span class="vsm__point" aria-hidden="true"></span>' + etiquette(mg) + '</span></span>'
        + '<span class="vsm__format-prix">' + (v ? (v.dispo ? esc(v.prix) : 'Épuisé') : '') + '</span></button></li>';
    }).join('');
    if (focusFormat) {                              /* la liste est redessinée : le focus clavier revient au format choisi */
      var bf = Array.prototype.filter.call(liste.querySelectorAll('[data-vs-format]'), function (x) { return x.getAttribute('data-vs-format') === focusFormat; })[0];
      if (bf) bf.focus({ preventScroll: true });
    }
    /* aucun format de ce plaid ne va : on le dit, avec la taille à chercher */
    if (repli) {
      var cible = mode === 'canape' ? 'Pour ce canapé, cherchez un plaid d’au moins ' + cm(longueur) + ' de long (idéal\u00a0: ' + cm(longueur + 40) + ').'
        : mode === 'lit' ? 'Pour ce lit, cherchez un plaid d’environ ' + (lit.l + 60) + ' x ' + cm(lit.L) + '.'
        : 'Pour vous envelopper jusqu’aux mollets, cherchez un plaid d’environ ' + r(0.62 * taille) + ' x ' + cm(Math.max(0.62 * taille * 1.3, 0.62 * taille + 30)) + '.';
      repli.hidden = unIdeal;
      if (!unIdeal) {
        var trop = mode === 'moi' ? modele(c).bas < 0 : mode === 'lit' ? !!modele(c).trop : modele(c).cotes > 30;
        var lien = mode === 'canape' ? ['/collections/plaid-canape', 'Voir les plaids de canapé'] : mode === 'lit' ? ['/collections/plaid-lit', 'Voir les plaids pour lit']
          : trop ? ['/collections/meilleures-ventes', 'Voir d’autres plaids'] : ['/collections/grand-plaid', 'Voir les grands plaids'];
        repli.innerHTML = 'Aucun format de ce plaid ne va tout à fait. ' + esc(cible) + ' <a href="' + lien[0] + '">' + lien[1] + '</a>';
      }
    }
    var v = variantePour(f.valeur), autres = autresChoix().noms;
    choixTexte.innerHTML = '<span>' + nom(f) + '</span>' + (autres.length ? '<span>' + esc(autres.join(' · ')) + '</span>' : '');
    ajouter.disabled = !v || !v.dispo;
    ajouterTexte.textContent = !v ? 'Indisponible' : v.dispo ? 'Ajouter au panier' : 'Épuisé dans cette couleur';
    prix.textContent = v && v.dispo ? v.prix : '';
    verdictCourt();
  }

  function lireCouleur() {
    var x = Array.prototype.filter.call(document.querySelectorAll('variant-selects input[type="radio"]:checked'), function (i) { return !/^taille/i.test(i.name || ''); })[0];
    if (x && teintes[x.value] && /^#[0-9a-f]{6}$/i.test(teintes[x.value])) { couleur = teintes[x.value]; return dlg.open ? rendre() : verdictCourt(); }
    var img = x && x.parentElement ? x.parentElement.querySelector('img') : null;
    if (!img) img = document.querySelector('.product-single__media img, .product-featured-media');
    var src = img ? (img.currentSrc || img.getAttribute('data-src') || img.src || '') : '';
    var suite = function () { if (dlg.open) rendre(); else verdictCourt(); };
    if (!src) return suite();
    if (src.indexOf('{width}') > -1) src = src.replace('{width}', '120');
    var im = new Image();
    im.onload = function () {
      try {
        var cv = document.createElement('canvas'); cv.width = cv.height = 24;
        var cx = cv.getContext('2d', { willReadFrequently: true }), w = im.naturalWidth, h = im.naturalHeight;
        cx.drawImage(im, w * 0.25, h * 0.25, w * 0.5, h * 0.5, 0, 0, 24, 24);
        var d = cx.getImageData(0, 0, 24, 24).data, t = [0, 0, 0], n = 0;
        for (var i = 0; i < d.length; i += 4) { t[0] += d[i]; t[1] += d[i + 1]; t[2] += d[i + 2]; n++; }
        couleur = '#' + t.map(function (v) { return ('0' + r(v / n).toString(16)).slice(-2); }).join('');
      } catch (e) { /* image d'une autre origine : la teinte par défaut reste */ }
      suite();
    };
    im.onerror = suite;
    im.src = src;
  }

  /* ---------- Ouverture et fermeture ---------- */
  var racineDoc = document.documentElement;
  function ouvrirTm(declencheur) {
    if (dlg.open) return;
    retour = declencheur || null;
    choix = null;
    var barre = window.innerWidth - racineDoc.clientWidth;
    racineDoc.style.setProperty('--vs-barre', barre + 'px');
    racineDoc.classList.add('vs-tm-ouvert');
    dlg.classList.remove('is-fermeture');
    dlg.style.transform = '';
    dlg.showModal();
    rendre();
    requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-ouvert'); }); });
    /* la scène se charge pendant le glissement du panneau */
    setTimeout(chargerMoteur, reduit.matches ? 0 : 120);
  }
  function fermerTm(ensuite) {
    if (!dlg.open) { if (ensuite) ensuite(); return; }
    dlg.classList.remove('is-ouvert');
    dlg.classList.add('is-fermeture');
    dlg.style.transform = '';
    var fini = false;
    var finir = function () {
      if (fini) return; fini = true;
      dlg.classList.remove('is-fermeture');
      dlg.close();
      if (ensuite) ensuite();
    };
    if (reduit.matches) return finir();
    dlg.addEventListener('transitionend', function te(e) { if (e.target === dlg) { dlg.removeEventListener('transitionend', te); finir(); } });
    setTimeout(finir, 420);
  }
  dlg.addEventListener('close', function () {
    racineDoc.classList.remove('vs-tm-ouvert');
    dlg.classList.remove('is-ouvert', 'is-fermeture');
    if (retour && document.contains(retour)) retour.focus();
    else { var t = document.querySelector('.vs-tm-declencheur, [data-vs-verdict-court]'); if (t) t.focus(); }
    retour = null;
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); fermerTm(); });   /* Échap : fermeture animée */
  dlg.addEventListener('click', function (e) { if (e.target === dlg) fermerTm(); });   /* clic sur le voile */

  /* Mobile : glisser l'en-tête vers le bas pour fermer */
  (function () {
    var poignee = dlg.querySelector('[data-vs-tm-glisser]'), y0 = null, t0 = 0, dy = 0;
    if (!poignee) return;
    poignee.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || !window.matchMedia('(max-width: 749px)').matches || e.target.closest('button')) return;
      y0 = e.clientY; t0 = Date.now(); dy = 0;
      dlg.classList.add('is-glisse');
      poignee.setPointerCapture(e.pointerId);
    });
    poignee.addEventListener('pointermove', function (e) {
      if (y0 === null) return;
      dy = Math.max(0, e.clientY - y0);
      dlg.style.transform = 'translateY(' + dy + 'px)';
    });
    var lacher = function () {
      if (y0 === null) return;
      var vitesse = dy / Math.max(1, Date.now() - t0);
      y0 = null;
      dlg.classList.remove('is-glisse');
      if (dy > 110 || vitesse > 0.6) fermerTm(); else dlg.style.transform = '';
    };
    poignee.addEventListener('pointerup', lacher);
    poignee.addEventListener('pointercancel', lacher);
  })();

  /* ---------- Actions ---------- */
  var tempo = null;
  function curseur(nomC, valeur) {
    if (nomC === 'canape') longueur = valeur; else taille = valeur;
    memoriser();
    /* la scène suit le curseur à la fin du geste (le canapé se refait, le plaid retombe) ; le texte, tout de suite */
    if (moteurEtat === 'pret') {
      clearTimeout(tempo);
      var f = formatChoisi(), m = modele(f);
      if (document.activeElement !== sorties[nomC]) sorties[nomC].value = valeur;
      curseurs[nomC].style.setProperty('--vs-p', (nomC === 'canape' ? (valeur - 120) / 240 : (valeur - 140) / 60) * 100 + '%');
      verdict.innerHTML = '<span class="vsm__pastille" aria-hidden="true"></span><span><strong>' + nom(f) + '</strong> ' + phrase(f, m) + '</span>';
      verdict.className = 'vsm__verdict vsm__verdict--' + m.etat;
      tempo = setTimeout(rendre, 160);
    } else rendre();
  }
  Object.keys(curseurs).forEach(function (k) {
    curseurs[k].addEventListener('input', function () { curseur(k, parseInt(curseurs[k].value, 10)); });
    /* la mesure se tape aussi au clavier (« 236 ») : bornée au curseur, appliquée à la validation */
    var champ = sorties[k], bornes = function (v) { return Math.max(+curseurs[k].min, Math.min(+curseurs[k].max, v)); };
    champ.addEventListener('change', function () {
      var v = parseInt(champ.value, 10);
      if (isNaN(v)) { champ.value = k === 'canape' ? longueur : taille; return; }
      v = bornes(v); champ.value = v; curseur(k, v);
    });
    champ.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); champ.blur(); } });
  });
  dlg.addEventListener('click', function (e) {
    if (e.target.closest('[data-vs-tm-fermer]')) { fermerTm(); return; }
    if (e.target.closest('[data-vsm-resume]')) {
      var vers = dlg.querySelector('#vsm-sur'), corps = dlg.querySelector('.vsm__corps');
      if (vers && corps) corps.scrollTo({ top: vers.closest('.vsm__etape').offsetTop - 8, behavior: reduit.matches ? 'auto' : 'smooth' });
      return;
    }
    var b = e.target.closest('[data-vsm-vue]');
    if (b && moteur) {
      var nomVue = b.getAttribute('data-vsm-vue');
      vues.querySelectorAll('[data-vsm-vue]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      montrerPlan(nomVue === 'plan');
      if (nomVue !== 'plan') moteur.vue(nomVue);
      return;
    }
    b = e.target.closest('[data-vs-mode]');
    if (b) {
      mode = b.getAttribute('data-vs-mode'); perso = true;
      /* mobile : les formats sont au-dessus des réglages ; après un changement de support, on remonte les voir */
      if (window.matchMedia('(max-width: 749px)').matches) { var cz = dlg.querySelector('.vsm__corps'); if (cz) cz.scrollTo({ top: 0, behavior: reduit.matches ? 'auto' : 'smooth' }); }
      if (moteur && !plan) { moteur.vue('troisquarts'); vues.querySelectorAll('[data-vsm-vue]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.getAttribute('data-vsm-vue') === 'troisquarts')); }); }
      rendre(); return;
    }
    b = e.target.closest('[data-vs-lit]');
    if (b) { lit = LITS[+b.getAttribute('data-vs-lit')]; memoriser(); rendre(); return; }
    b = e.target.closest('[data-vs-format]');
    if (!b) return;
    var v = b.getAttribute('data-vs-format');
    choix = v;
    rendre();
    var x = radiosTaille().filter(function (i) { return i.value === v; })[0];
    if (x && !x.checked) {
      /* les identifiants des boutons de Honey finissent par un retour à la ligne : pas de sélecteur label[for=…]
         (il levait une erreur et le clic ne partait pas, constaté le 28/10) ; input.labels suit l'attribut for */
      var l = (x.labels && x.labels[0]) || (x.nextElementSibling && x.nextElementSibling.querySelector('label'));
      (l || x).click();
    }
  });
  ajouter.addEventListener('click', function () {
    var f = formatChoisi(), v = variantePour(f.valeur);
    if (!v || !v.dispo || ajouter.getAttribute('aria-busy') === 'true') return;
    ajouter.setAttribute('aria-busy', 'true');
    var debut = Date.now();
    (function essayer() {
      var bouton = document.querySelector('.product-section [data-add-to-cart]');
      var form = bouton && bouton.closest('form');
      var id = form && form.querySelector('[name="id"]');
      /* Honey met la variante du formulaire à jour après un aller-retour réseau : on attend qu'elle soit la bonne */
      if (id && String(id.value) !== String(v.id)) {
        if (Date.now() - debut < 3000) return setTimeout(essayer, 120);
        ajouter.removeAttribute('aria-busy');
        ajouterTexte.textContent = 'Réessayez dans un instant';
        return;
      }
      fermerTm(function () {
        ajouter.removeAttribute('aria-busy');
        if (bouton && !bouton.disabled) bouton.click();
      });
    })();
  });

  /* Déclencheurs : « Trouver ma taille » à côté du libellé « Taille » (Honey redessine le bloc des variantes à chaque
     choix : reposé par l'observateur), verdict sous les tailles, bouton de l'accordéon des repères */
  var ICONE = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><path d="M10 2.2l6.8 3.9v7.8L10 17.8l-6.8-3.9V6.1z"/><path d="M3.2 6.1L10 10l6.8-3.9M10 10v7.8"/></svg>';
  function poser() {
    Array.prototype.forEach.call(document.querySelectorAll('variant-selects fieldset'), function (fs) {
      var r0 = fs.querySelector('input[type="radio"]');
      if (!r0 || !/^taille/i.test(r0.name || '') || fs.querySelector('.vs-tm-declencheur')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'vs-tm-declencheur';
      b.setAttribute('data-vs-tm-ouvrir', ''); b.setAttribute('aria-haspopup', 'dialog'); b.setAttribute('aria-controls', 'vs-tm');
      b.innerHTML = ICONE + '<span>Trouver ma taille</span><span class="vs-tm-declencheur__3d">3D</span>';
      fs.classList.add('vs-tm-fs');
      var lg = fs.querySelector('legend');
      if (lg) lg.insertAdjacentElement('afterend', b); else fs.insertBefore(b, fs.firstChild);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-vs-tm-repli]'), function (a) { a.hidden = true; });
    Array.prototype.forEach.call(document.querySelectorAll('.vs-tm-ouvrir[hidden]'), function (b) { b.hidden = false; });
    verdictCourt();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vs-tm-ouvrir]');
    if (!b) return;
    e.preventDefault();
    ouvrirTm(b);
  });
  ['pointerover', 'focusin'].forEach(function (t) {
    document.addEventListener(t, function (e) { if (e.target.closest && e.target.closest('[data-vs-tm-ouvrir]')) prechargerMoteur(); }, { passive: true });
  });
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { poser(); lireCouleur(); }, 60); });
  } else {
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) setTimeout(lireCouleur, 60); });
  }
  var zoneFiche = document.querySelector('.product-section') || document.querySelector('product-information');
  if (zoneFiche && 'MutationObserver' in window) {
    var tm = null;
    new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(poser, 50); }).observe(zoneFiche, { childList: true, subtree: true });
  }
  if ('ResizeObserver' in window) {
    var largeur = 0;
    new ResizeObserver(function () { if (dlg.open && (moteurEtat === 'echec' || plan) && dessin.clientWidth !== largeur) { largeur = dessin.clientWidth; dessiner(formatChoisi()); } }).observe(dessin);
  }
  poser();
  lireCouleur();
})();

/* Fiche mobile : les vignettes laissent la place à un compteur « 1 / 11 » sur la photo (Slick, jQuery de Honey). */
(function () {
  function poser() {
    var g = document.querySelector('.product-section .product-single__gallery');
    if (!g || !window.jQuery || !window.jQuery(g).hasClass('slick-initialized')) return false;
    var groupe = g.closest('.product-single__media-group') || g.parentElement;
    var c = document.createElement('span'); c.className = 'vs-compteur'; c.setAttribute('aria-hidden', 'true');
    groupe.appendChild(c);
    var maj = function (ev, s, i) { var n = g.querySelectorAll('.slick-slide:not(.slick-cloned)').length; c.textContent = ((i || 0) + 1) + ' / ' + n; };
    window.jQuery(g).on('afterChange', maj); maj(null, null, window.jQuery(g).slick('slickCurrentSlide'));
    return true;
  }
  var essais = 0;
  (function attendre() { if (!poser() && essais++ < 40) setTimeout(attendre, 250); })();
})();


/* Passe 8 (retour 8 de Solal, benchmark : Ferm Living, Magic Linen) : sur ordinateur, la colonne d'achat de la fiche
   reste entière à l'écran pendant toute la galerie et les détails (CSS : position sticky, 20-fiche.css). Le « panneau
   compact » de Honey (classe product__info-container--modal, posée au défilement par l'écouteur que product-content.js
   branche) est débranché : il sautait en haut de l'écran avec une animation et retirait la réassurance et les logos.
   --vs-col-h donne la hauteur de la colonne au CSS : plus haute que l'écran, elle colle par le bas (le bouton et la
   réassurance restent visibles). Les scripts de Honey sont en defer, après le nôtre : on attend DOMContentLoaded. */
(function () {
  function brancher() {
    var pi = document.querySelector('product-information');
    var col = document.querySelector('.product-section .product__info-container');
    if (!pi || !col) return;
    if (pi.onScrollToolsHandler) window.removeEventListener('scroll', pi.onScrollToolsHandler, false);
    col.classList.remove('product__info-container--modal', 'product__info-container--modal--out', 'background-modal');
    var poser = function () { col.style.setProperty('--vs-col-h', col.offsetHeight + 'px'); };
    poser();
    if ('ResizeObserver' in window) new ResizeObserver(poser).observe(col);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher);
  else brancher();
})();


/* Accueil (sections vs-*, portées de la maquette) : nuancier des matières, panneaux des tailles, date de livraison du
   cadeau, entrées au défilement (une fois ; ce qui est déjà à l'écran au chargement n'est jamais caché). */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Entrées : marquées vues d'office si elles sont déjà dans l'écran, observées sinon */
  var entrees = $$('.vs-entree, .vs-volet');
  if (entrees.length) {
    var h = window.innerHeight;
    entrees.forEach(function (el) { var r = (el.classList.contains('vs-volet') ? el.parentElement : el).getBoundingClientRect(); if (r.top < h) el.classList.add('is-vu'); });
    document.documentElement.classList.add('vs-js');
    if ('IntersectionObserver' in window && !reduit) {
      var vu = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (!e.isIntersecting) return; (e.target.vsCible || e.target).classList.add('is-vu'); vu.unobserve(e.target); });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      entrees.forEach(function (el) {
        if (el.classList.contains('is-vu')) return;
        if (el.classList.contains('vs-volet')) { el.parentElement.vsCible = el; vu.observe(el.parentElement); } else vu.observe(el);
      });
    } else entrees.forEach(function (el) { el.classList.add('is-vu'); });
  }

  /* Nuancier des matières : la photo, le fait, le prix et le lien changent avec la matière */
  var MATIERES = {
    polaire: { teinte: 'var(--vs-sable)', alt: 'Un plaid polaire côtelé beige posé sur l’accoudoir d’un canapé en lin, à la lumière de la fenêtre',
      fait: 'Chaude dès qu’on s’y glisse, légère sur les genoux, elle passe en machine à 30 °C. Du 70 x 100 cm pour les genoux au 230 x 250 cm pour un lit.', prix: 'De 19,90 à 240 €', lien: '/collections/plaid-polaire', libelle: 'Voir les plaids polaires' },
    fourrure: { teinte: 'var(--vs-chocolat)', sombre: true, alt: 'Une main posée dans le poil long d’un plaid en fausse fourrure marron chocolat',
      fait: 'Ici, toute la fourrure est fausse : polyester ou acrylique, aucun animal. Poil ras ou long, façon lapin, loup ou léopard.', prix: 'De 19,90 à 279,90 €', lien: '/collections/plaid-fourrure', libelle: 'Voir la fausse fourrure' },
    maille: { teinte: 'var(--vs-rose)', alt: 'Un plaid en grosse maille crème sur un fauteuil canné',
      fait: 'Des mailles géantes qu’on voit de loin et qu’on sent sous les doigts, le plus souvent en fil de polyester épais. Pour le canapé, un fauteuil ou le pied du lit.', prix: 'De 42,90 à 299,90 €', lien: '/collections/plaid-grosse-maille', libelle: 'Voir la grosse maille' },
    gaze: { teinte: 'var(--vs-sauge)', alt: 'Un plaid en gaze de coton taupe froissé au pied d’un lit',
      fait: 'Un tissu léger et aéré, parfois en double couche, qu’on garde aux beaux jours comme en hiver sous une polaire.', prix: 'De 32,90 à 139,90 €', lien: '/collections/plaid-gaze-de-coton', libelle: 'Voir la gaze de coton' },
    sweat: { teinte: 'var(--vs-ardoise)', sombre: true, alt: 'Une femme assise sur un canapé, dans un sweat plaid bleu marine, une tasse entre les mains',
      fait: 'Un plaid qu’on enfile : il reste en place quand vous vous levez, les mains libres. Pour adulte, enfant ou bébé.', prix: 'De 29,90 à 199,90 €', lien: '/collections/sweat-plaid', libelle: 'Voir les sweats plaids' }
  };
  var bloc = $('[data-vs-matieres]');
  if (bloc) {
    var scene = $('[data-vs-scene]', bloc), im = $('[data-vs-matiere-img]', bloc), fait = $('[data-vs-matiere-fait]', bloc);
    var prixM = $('[data-vs-matiere-prix]', bloc), lienM = $('[data-vs-matiere-lien]', bloc);
    var cadre = $('[data-vs-matiere-cadre]', bloc), contenu = $('[data-vs-matiere-contenu]', bloc), horloge = null, tour = 0;
    var boutons = $$('[data-matiere]', bloc);
    var precharge = function () { boutons.forEach(function (b) { var i = new Image(); i.src = b.getAttribute('data-img'); }); };
    if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { precharge(); io.disconnect(); } }, { rootMargin: '400px 0px' }); io.observe(bloc); }
    boutons.forEach(function (b) {
      var m = MATIERES[b.dataset.matiere]; if (!m) return;
      b.style.setProperty('--teinte', m.teinte);
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-pressed') === 'true') return;
        boutons.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        clearTimeout(horloge); var ce = ++tour;
        [cadre, contenu].forEach(function (el) { if (el) el.classList.add('is-change'); });
        horloge = setTimeout(function () {
          if (ce !== tour) return;
          if (scene) { scene.style.setProperty('--teinte', m.teinte); scene.toggleAttribute('data-sombre', !!m.sombre); }
          if (im) { im.removeAttribute('srcset'); im.src = b.getAttribute('data-img'); im.alt = m.alt; }
          if (fait) fait.textContent = m.fait; if (prixM) prixM.textContent = m.prix;
          if (lienM) { lienM.href = m.lien; lienM.textContent = m.libelle; }
          var montrer = function () { if (ce !== tour) return; [cadre, contenu].forEach(function (el) { if (el) el.classList.remove('is-change'); }); };
          if (im && im.decode) im.decode().then(montrer, montrer); else montrer();
        }, reduit ? 0 : 120);
      });
    });
  }

  /* Panneaux « Quelle taille de plaid ? » : un seul ouvert */
  $$('[data-vs-panneaux]').forEach(function (g) {
    var ps = $$('.vs-panneau', g);
    ps.forEach(function (p) {
      var b = $('.vs-panneau__btn', p); if (!b) return;
      b.addEventListener('click', function () {
        ps.forEach(function (q) {
          var o = q === p; q.classList.toggle('is-ouvert', o);
          var bq = $('.vs-panneau__btn', q), cq = $('.vs-panneau__contenu', q);
          if (bq) bq.setAttribute('aria-expanded', String(o)); if (cq) cq.hidden = !o;
        });
      });
    });
  });

  /* Date de livraison hors du panier (cadeau) : 6 à 9 jours ouvrés, week-ends et fériés fixes exclus */
  var FERIES = ['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25'];
  function ouvre(d) { var j = d.getDay(); return j !== 0 && j !== 6 && FERIES.indexOf((d.getMonth() + 1) + '-' + d.getDate()) < 0; }
  function dans(n) { var d = new Date(); d.setHours(12, 0, 0, 0); while (n > 0) { d.setDate(d.getDate() + 1); if (ouvre(d)) n--; } return d; }
  function fourchette(a0, b0) {
    var a = dans(a0), b = dans(b0), jour = function (d) { return d.getDate() === 1 ? '1er' : String(d.getDate()); }, mois = function (d) { return d.toLocaleDateString('fr-FR', { month: 'long' }); };
    return a.getMonth() === b.getMonth() ? 'entre le ' + jour(a) + ' et le ' + jour(b) + ' ' + mois(b) : 'entre le ' + jour(a) + ' ' + mois(a) + ' et le ' + jour(b) + ' ' + mois(b);
  }
  $$('[data-vs-date-livraison]').forEach(function (el) {
    el.textContent = 'Commandé aujourd’hui, il arrive chez vous ' + fourchette(Number(el.dataset.min) || 6, Number(el.dataset.max) || 9) + ' (6 à 9 jours ouvrés). Livraison offerte et suivie.';
  });
})();

/* Halezia, passe 9 (29/10/2026) : avis de la fiche (section vs-avis-fiche). Lit l'API publique de Trustoo, qui répond
   aux appels venus de la boutique (CORS), quand la section approche de l'écran : un appel de 100 avis, puis filtres, tri
   et pagination dans la page, sans autre appel. Tous les avis sont gardés ; le badge vient du champ verified_badge de
   Trustoo. Le texte des clients passe par textContent, jamais par innerHTML. */
(() => {
  const API = 'https://api.trustoo.io/api/v1/reviews/get_product_reviews?shop_id=81607754060';
  const PAS = 6;
  const NOTE = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  const DATE = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  const ETOILE = 'M9 .57l2.12 6.08 6.44.13-5.14 3.9 1.87 6.17L9 13.17l-5.29 3.68 1.87-6.17L.44 6.78l6.44-.13z';
  const COCHE = 'M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm-1.79-4.55a.8.8 0 0 0 1.15 0L12.5 6.5a.82.82 0 0 0-1.15-1.16L6.78 9.71 4.11 7.01a.8.8 0 0 0-1.15 0 .82.82 0 0 0 0 1.16l3.25 3.28Z';
  const NS = 'http://www.w3.org/2000/svg';
  /* Sujets (veille du 29/10 : puces de sujets) : comptés sur le texte des avis, accents ignorés ; une puce dès 2 avis */
  const SUJETS = [
    ['Douceur', /\b(doux|douce|douceur|moelleu|toucher|soyeu)/],
    ['Chaleur', /\b(chaud|chaude|chaleur|hiver|froid)/],
    ['Épaisseur', /\b(epais|epaisse|epaisseur|mince)/],
    ['Taille', /\b(taille|grand|grande|petit|petite|dimension|longueur|largeur)/],
    ['Couleur', /\b(couleur|teinte|coloris)/],
    ['Qualité', /\b(qualite|solide|finition|durable)/],
    ['Livraison', /\b(livraison|livre|arrive|delai|colis|expedition)/]
  ];
  const plat = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  const el = (tag, cls, txt) => { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; };
  const svg = (vb, d, cls) => {
    const s = document.createElementNS(NS, 'svg'); s.setAttribute('viewBox', vb); s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false');
    if (cls) s.setAttribute('class', cls);
    const p = document.createElementNS(NS, 'path'); p.setAttribute('d', d); p.setAttribute('fill-rule', 'evenodd'); p.setAttribute('clip-rule', 'evenodd'); s.appendChild(p); return s;
  };
  const etoiles = (note) => {
    const w = el('span', 'vs-et'); w.setAttribute('role', 'img'); w.setAttribute('aria-label', `${NOTE.format(note).replace(',0', '')} étoiles sur 5`);
    w.style.setProperty('--vs-et-pct', `${Math.max(0, Math.min(100, note * 20))}%`);
    for (let i = 0; i < 2; i++) {
      const s = document.createElementNS(NS, 'svg'); s.setAttribute('viewBox', '0 0 98 17'); s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false');
      s.setAttribute('class', 'vs-et__rang' + (i ? ' vs-et__rang--plein' : ''));
      for (let k = 0; k < 5; k++) { const p = document.createElementNS(NS, 'path'); p.setAttribute('d', ETOILE); p.setAttribute('transform', `translate(${k * 20} 0)`); s.appendChild(p); }
      w.appendChild(s);
    }
    return w;
  };
  const nom = (a) => (a || '').trim().replace(/\s+/g, ' ') || 'Client';
  const quand = (s) => { const d = new Date((s || '').replace(' ', 'T')); return isNaN(d) ? '' : DATE.format(d); };
  const vignette = (r) => r.thumb_src || r.card_thumbnail_url || r.src;

  async function lire(q) {
    const rep = await fetch(API + q, { credentials: 'omit' });
    if (!rep.ok) throw new Error('Trustoo ' + rep.status);
    const j = await rep.json();
    if (j.code !== 0) throw new Error('Trustoo ' + j.code);
    return j.data;
  }

  function monter(root) {
    const mode = root.dataset.mode;
    const q = (s) => root.querySelector(s);
    const liste = q('[data-avf-liste]');
    const etat = q('[data-avf-etat]');
    const plus = q('[data-avf-plus]');
    const tri = q('[data-avf-tri]');
    const btnPhotos = q('[data-avf-filtre-photos]');
    const btnEffacer = q('[data-avf-effacer]');
    const visio = q('[data-avf-visio]');
    let tous = [], vus = PAS, filtreNote = 0, filtrePhotos = false, filtreSujet = '', ordre = 'recents';
    let medias = [], posMedia = 0;

    function resume() {
      if (mode !== 'produit' || !tous.length) return;
      const n = tous.length;
      const moy = tous.reduce((s, r) => s + r.star, 0) / n;
      q('[data-avf-moyenne]').textContent = NOTE.format(moy);
      const zone = q('[data-avf-etoiles]'); zone.replaceChildren(etoiles(moy)); zone.firstChild.classList.add('vs-et--grand');
      const ver = tous.filter((r) => r.verified_badge === 1).length;
      q('[data-avf-total]').textContent = `${n} avis client${n > 1 ? 's' : ''}`;
      for (let e = 5; e >= 1; e--) {
        const c = tous.filter((r) => r.star === e).length;
        const b = q(`[data-avf-filtre-note="${e}"]`);
        b.querySelector('.vs-avf__rempli').style.setProperty('--vs-part', (c / n).toFixed(3));
        b.querySelector('[data-avf-nb]').textContent = c;
        b.disabled = c === 0;
        b.setAttribute('aria-label', `${e} étoile${e > 1 ? 's' : ''} : ${c} avis${c ? ', afficher seulement ceux-ci' : ''}`);
      }
    }

    function galerie() {
      medias = [];
      tous.forEach((r, ri) => (r.resources || []).forEach((m) => { if (m.resource_type === 1 || !m.resource_type) medias.push({ r, m, ri }); }));
      const zone = q('[data-avf-photos]');
      if (!medias.length) { zone.hidden = true; return; }
      const ul = q('[data-avf-galerie]'); ul.replaceChildren();
      const MAX = 10;
      medias.slice(0, MAX).forEach((x, i) => {
        const li = el('li'); const b = el('button', 'vs-avf__vignette'); b.type = 'button';
        b.setAttribute('aria-label', `Voir la photo de ${nom(x.r.author)}`);
        const img = el('img'); img.src = vignette(x.m); img.alt = ''; img.loading = 'lazy'; img.decoding = 'async'; img.width = 96; img.height = 96;
        b.appendChild(img);
        if (i === MAX - 1 && medias.length > MAX) { b.appendChild(el('span', 'vs-avf__vignette-plus', `+${medias.length - MAX + 1}`)); b.setAttribute('aria-label', `Voir les ${medias.length} photos de clients`); }
        b.addEventListener('click', () => ouvrir(i));
        li.appendChild(b); ul.appendChild(li);
      });
      zone.hidden = false;
      if (btnPhotos) {
        const nbAvecPhotos = tous.filter((r) => (r.resources || []).length).length;
        btnPhotos.querySelector('[data-avf-nb-photos]').textContent = `(${nbAvecPhotos})`;
        btnPhotos.hidden = mode !== 'produit' || nbAvecPhotos === 0 || nbAvecPhotos === tous.length;
      }
    }

    function selection() {
      let L = tous.slice();
      if (filtreNote) L = L.filter((r) => r.star === filtreNote);
      if (filtrePhotos) L = L.filter((r) => (r.resources || []).length);
      if (filtreSujet) { const re = SUJETS.find((s) => s[0] === filtreSujet)[1]; L = L.filter((r) => re.test(plat(r.content))); }
      const t = (r) => new Date((r.commented_at || '').replace(' ', 'T')).getTime() || 0;
      if (ordre === 'recents') L.sort((a, b) => t(b) - t(a));
      else if (ordre === 'haute') L.sort((a, b) => b.star - a.star || t(b) - t(a));
      else if (ordre === 'basse') L.sort((a, b) => a.star - b.star || t(b) - t(a));
      return L; // pertinence : l'ordre « comprehensive » de Trustoo
    }

    function carte(r) {
      const li = el('li', 'vs-avf__avis');
      const l1 = el('div', 'vs-avf__l1');
      l1.appendChild(etoiles(r.star));
      const d = quand(r.commented_at); if (d) { const t = el('time', 'vs-avf__date', d); t.dateTime = (r.commented_at || '').slice(0, 10); l1.appendChild(t); }
      li.appendChild(l1);
      const qui = el('p', 'vs-avf__auteur'); qui.appendChild(el('span', 'vs-avf__nom', nom(r.author)));
      if (r.verified_badge === 1) {
        const v = el('span', 'vs-avf__verifie'); v.appendChild(svg('0 0 16 16', COCHE)); v.appendChild(document.createTextNode('Achat vérifié'));
        v.title = 'L’auteur de cet avis a passé une commande confirmée sur notre boutique.'; qui.appendChild(v);
      }
      li.appendChild(qui);
      const txt = (r.content || '').trim();
      if (txt) {
        const p = el('p', 'vs-avf__texte', txt); li.appendChild(p);
        if (txt.length > 360) {
          p.classList.add('vs-avf__texte--coupe');
          const b = el('button', 'vs-avf__lire', 'Lire la suite'); b.type = 'button'; b.setAttribute('aria-expanded', 'false');
          b.addEventListener('click', () => { const o = p.classList.toggle('vs-avf__texte--coupe'); b.textContent = o ? 'Lire la suite' : 'Réduire'; b.setAttribute('aria-expanded', String(!o)); });
          li.appendChild(b);
        }
      }
      const res = (r.resources || []).filter((m) => m.resource_type === 1 || !m.resource_type);
      if (res.length) {
        const ul = el('ul', 'vs-avf__photos-avis'); ul.setAttribute('role', 'list');
        res.forEach((m) => {
          const i = medias.findIndex((x) => x.m === m);
          const lib = el('li'); const b = el('button', 'vs-avf__vignette vs-avf__vignette--petite'); b.type = 'button'; b.setAttribute('aria-label', `Agrandir la photo de ${nom(r.author)}`);
          const img = el('img'); img.src = vignette(m); img.alt = ''; img.loading = 'lazy'; img.decoding = 'async'; img.width = 72; img.height = 72;
          b.appendChild(img); b.addEventListener('click', () => ouvrir(i)); lib.appendChild(b); ul.appendChild(lib);
        });
        li.appendChild(ul);
      }
      const cp = r.corresponding_product;
      if (mode === 'boutique' && cp && cp.product_url) {
        const a = el('a', 'vs-avf__produit'); a.href = cp.product_url.replace(/^https?:\/\/[^/]+/, '');
        a.textContent = `À propos du ${cp.product_name}`; li.appendChild(a);
      }
      if ((r.reply_content || '').trim()) {
        const rp = el('div', 'vs-avf__reponse'); rp.appendChild(el('p', 'vs-avf__reponse-qui', 'Réponse de Halezia'));
        rp.appendChild(el('p', null, r.reply_content.trim())); li.appendChild(rp);
      }
      return li;
    }

    function afficher(anime) {
      const L = selection();
      const avant = liste.children.length;
      liste.replaceChildren(...L.slice(0, vus).map(carte));
      if (anime) [...liste.children].slice(avant).forEach((c, i) => { c.classList.add('vs-avf__avis--entre'); c.style.setProperty('--i', i); });
      plus.hidden = L.length <= vus;
      plus.textContent = `Voir plus d’avis (${L.length - Math.min(vus, L.length)})`;
      const filtre = filtreNote || filtrePhotos || filtreSujet;
      root.querySelectorAll('[data-avf-sujet]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.avfSujet === filtreSujet)));
      btnEffacer.hidden = !filtre;
      etat.textContent = filtre ? `${L.length} avis correspond${L.length > 1 ? 'ent' : ''}` : '';
      root.querySelectorAll('[data-avf-filtre-note]').forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.avfFiltreNote === filtreNote)));
      if (btnPhotos) btnPhotos.setAttribute('aria-pressed', String(filtrePhotos));
    }

    function ouvrir(i) {
      if (!medias.length || typeof visio.showModal !== 'function') return;
      posMedia = Math.max(0, Math.min(medias.length - 1, i));
      montrer();
      visio.showModal();
      visio.querySelector('[data-avf-fermer]').focus();
    }
    function montrer() {
      const x = medias[posMedia];
      const img = visio.querySelector('[data-avf-visio-img]');
      img.src = x.m.src || vignette(x.m);
      img.alt = `Photo envoyée par ${nom(x.r.author)}`;
      const t = visio.querySelector('[data-avf-visio-texte]'); t.replaceChildren();
      const l1 = el('div', 'vs-avf__l1'); l1.appendChild(etoiles(x.r.star)); const d = quand(x.r.commented_at); if (d) l1.appendChild(el('span', 'vs-avf__date', d)); t.appendChild(l1);
      const qui = el('p', 'vs-avf__auteur'); qui.appendChild(el('span', 'vs-avf__nom', nom(x.r.author)));
      if (x.r.verified_badge === 1) { const v = el('span', 'vs-avf__verifie'); v.appendChild(svg('0 0 16 16', COCHE)); v.appendChild(document.createTextNode('Achat vérifié')); qui.appendChild(v); }
      t.appendChild(qui);
      if ((x.r.content || '').trim()) t.appendChild(el('p', 'vs-avf__texte', x.r.content.trim()));
      visio.querySelector('[data-avf-visio-pos]').textContent = medias.length > 1 ? `${posMedia + 1} sur ${medias.length}` : '';
      visio.querySelector('[data-avf-prec]').hidden = visio.querySelector('[data-avf-suiv]').hidden = medias.length < 2;
    }

    visio.querySelector('[data-avf-fermer]').addEventListener('click', () => visio.close());
    visio.querySelector('[data-avf-prec]').addEventListener('click', () => { posMedia = (posMedia - 1 + medias.length) % medias.length; montrer(); });
    visio.querySelector('[data-avf-suiv]').addEventListener('click', () => { posMedia = (posMedia + 1) % medias.length; montrer(); });
    visio.addEventListener('click', (e) => { if (e.target === visio) visio.close(); });
    visio.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); visio.querySelector('[data-avf-prec]').click(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); visio.querySelector('[data-avf-suiv]').click(); }
    });

    root.querySelectorAll('[data-avf-filtre-note]').forEach((b) => b.addEventListener('click', () => {
      const e = +b.dataset.avfFiltreNote; filtreNote = filtreNote === e ? 0 : e; vus = PAS; afficher(false);
      liste.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }));
    if (btnPhotos) btnPhotos.addEventListener('click', () => { filtrePhotos = !filtrePhotos; vus = PAS; afficher(false); });
    btnEffacer.addEventListener('click', () => { filtreNote = 0; filtrePhotos = false; filtreSujet = ''; vus = PAS; afficher(false); });
    function sujets() {
      if (mode !== 'produit' || tous.length < 5) return;
      const zone = q('.vs-avf__filtres');
      SUJETS.forEach(([nom, re]) => {
        const n = tous.filter((r) => re.test(plat(r.content))).length;
        if (n < 2) return;
        const b = el('button', 'vs-avf__puce', nom + ' '); b.type = 'button'; b.dataset.avfSujet = nom; b.setAttribute('aria-pressed', 'false');
        b.appendChild(el('span', 'vs-avf__puce-nb', `(${n})`));
        b.addEventListener('click', () => { filtreSujet = filtreSujet === nom ? '' : nom; vus = PAS; afficher(false); });
        zone.insertBefore(b, btnEffacer);
      });
    }
    tri.addEventListener('change', () => { ordre = tri.value; vus = PAS; afficher(false); });
    plus.addEventListener('click', () => { vus += PAS; afficher(true); });

    async function charger() {
      try {
        if (mode === 'produit') {
          const d = await lire(`&limit=100&page=1&product_id=${root.dataset.produit}&sort_by=comprehensive-descending`);
          tous = d.list || [];
          let p = 1;
          while (p < (d.page && d.page.total_page) && p < 5) { p++; const s = await lire(`&limit=100&page=${p}&product_id=${root.dataset.produit}&sort_by=comprehensive-descending`); tous = tous.concat(s.list || []); }
        } else {
          const d = await lire('&limit=60&page=1&sort_by=comprehensive-descending&scene=3&review_filter_type=2&no_empty=1&has_resource=1');
          // d'abord les avis des plaids qui partagent un mot du titre (fourrure, polaire, maille…), puis les autres
          const mots = plat(root.dataset.titre || '').split(/[^a-z]+/).filter((m) => m.length > 4 && m !== 'plaid' && m !== 'plaids');
          const score = (r) => { const n = plat((r.corresponding_product || {}).product_name || ''); return mots.some((m) => n.includes(m)) ? 1 : 0; };
          tous = (d.list || []).map((r, i) => ({ r, i, s: score(r) })).sort((a, b) => b.s - a.s || a.i - b.i).map((x) => x.r).slice(0, 12);
        }
        if (!tous.length) { liste.replaceChildren(); etat.textContent = 'Aucun avis à afficher pour le moment.'; return; }
        resume();
        galerie();
        sujets();
        q('[data-avf-outils]').hidden = mode !== 'produit' || tous.length < 4;
        afficher(false);
        root.classList.add('vs-avf--pret');
      } catch (err) {
        liste.replaceChildren();
        etat.textContent = 'Les avis n’ont pas pu se charger. Rechargez la page pour réessayer.';
      }
    }

    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); charger(); } }, { rootMargin: '900px 0px' });
    io.observe(root);
    // Geste : les barres de la répartition se remplissent quand le résumé entre dans l'écran
    const barres = q('[data-avf-barres]');
    if (barres && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.dataset.anim = '1';
      const vu = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { vu.disconnect(); requestAnimationFrame(() => root.classList.add('vs-avf--vu')); } }, { threshold: 0.4 });
      vu.observe(barres);
    }
  }

  const go = () => document.querySelectorAll('[data-vs-avis]').forEach(monter);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();

  /* Note sous le titre et lien « Ajuster à mon canapé » : descente douce vers les avis ou le conseil de taille
     (l'en-tête collant ne cache pas le titre de la section) */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href="#avis"], a[data-vs-vers-conseil]');
    const cible = a && document.getElementById(a.hasAttribute('data-vs-vers-conseil') ? 'vs-conseil' : 'avis');
    if (!a || !cible) return;
    e.preventDefault();
    const h = (document.querySelector('.header-wrapper, sticky-header, .shopify-section-header')?.getBoundingClientRect().height) || 64;
    window.scrollTo({ top: cible.getBoundingClientRect().top + window.scrollY - h - 16, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
})();

/* Tiroir panier, passe 9 (montant du bouton Commander) : remplacé à la passe 13 (02/11/2026) par js/90-vs13-panier.js (tiroir à nous). */

/* Halezia, passe 9 (29/10/2026) : accueil. Matières : la photo suit la ligne survolée ou focalisée. Tailles à l'échelle :
   au premier passage dans l'écran, les plaids se déplient et la cote se trace (classe is-vu). Sans script, tout est
   visible ; mouvement réduit : rien ne bouge. */
(() => {
  const reduit = matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-vs9-mat]').forEach((bloc) => {
    const liste = bloc.querySelector('.vs9-mat__liste');
    const items = [...bloc.querySelectorAll('[data-vs9-mat-item]')];
    const photos = [...bloc.querySelectorAll('[data-vs9-mat-photo]')];
    const activer = (i) => {
      items.forEach((it, k) => it.classList.toggle('is-actif', k === i));
      photos.forEach((p, k) => p.classList.toggle('is-actif', k === i));
    };
    items.forEach((it, i) => {
      it.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') activer(i); });
      it.addEventListener('focusin', () => activer(i));
    });
    if (liste) {
      liste.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') liste.classList.add('is-survol'); });
      liste.addEventListener('pointerleave', () => liste.classList.remove('is-survol'));
      liste.addEventListener('focusin', () => liste.classList.add('is-survol'));
      liste.addEventListener('focusout', (e) => { if (!liste.contains(e.relatedTarget)) liste.classList.remove('is-survol'); });
    }
  });

  document.querySelectorAll('[data-vs9-tailles]').forEach((bloc) => {
    if (reduit || !('IntersectionObserver' in window)) return;
    const liste = bloc.querySelector('.vs9-tailles__liste');
    if (!liste) return;
    // déjà visible au chargement (retour arrière, ancre) : pas d'animation
    const r = liste.getBoundingClientRect();
    if (r.top < innerHeight && r.bottom > 0) return;
    bloc.dataset.anim = '1';
    const io = new IntersectionObserver((es) => {
      if (es.some((e) => e.isIntersecting)) { io.disconnect(); requestAnimationFrame(() => bloc.classList.add('is-vu')); }
    }, { threshold: 0.35 });
    io.observe(liste);
  });
})();

/* Halezia, passe 9 (29/10/2026) : intro de collection repliée à deux lignes sur mobile, « Lire la suite » la déplie.
   Passe 12 : l'intro de la tête (vs11-tete) s'affiche en entier (le H1 posé sur la photo a libéré la place) ; le repli
   ne vise plus que l'ancienne intro, s'il en reste une. */
(() => {
  const intro = document.querySelector('.vs-coll__intro:not(.vs11-tete__intro)');
  if (!intro || !matchMedia('(max-width: 749px)').matches) return;
  intro.classList.add('vs-coll__intro--court');
  if (intro.scrollHeight <= intro.clientHeight + 2) { intro.classList.remove('vs-coll__intro--court'); return; }
  const b = document.createElement('button');
  b.type = 'button'; b.className = 'vs-coll__suite'; b.textContent = 'Lire la suite'; b.setAttribute('aria-expanded', 'false');
  b.addEventListener('click', () => {
    const court = intro.classList.toggle('vs-coll__intro--court');
    b.textContent = court ? 'Lire la suite' : 'Réduire'; b.setAttribute('aria-expanded', String(!court));
  });
  intro.after(b);
})();

/* Filtres (retours de Solal du 29/10) : une pastille devant chaque couleur du filtre « Couleur » (les valeurs viennent de
   Search & Discovery, sans pastille), et trois tranches de prix en un clic dans le filtre « Prix ». Réappliqué quand Honey
   redessine les filtres après un choix. */
(() => {
  const TEINTES = { beige: '#d8c4a6', blanc: '#ffffff', 'blanc casse': '#f1ece2', creme: '#efe6d2', ecru: '#efe6d2', gris: '#9a9a9a', noir: '#1f1d1b',
    marron: '#6b4630', chocolat: '#4a3326', camel: '#b8875a', terracotta: '#b5583a', terracota: '#b5583a', rouge: '#a8322d', bordeaux: '#6e1f2a',
    orange: '#d9822b', jaune: '#e3b23c', moutarde: '#d8b664', vert: '#5f7a52', kaki: '#6b6b45', bleu: '#3f5f8a', marine: '#26324d',
    violet: '#6f4d8a', rose: '#e3a9b4', taupe: '#8b7d70', sable: '#dccab6' };
  const plat = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\(.*$/, '').trim();
  function pastilles(racine) {
    // valeurs sans produit dans la collection (« Animaux (0) ») : masquées, sauf si elles sont cochées
    racine.querySelectorAll('[id^="Wrap-Filter-couleur"] li, [id^="Wrap-Filter-color"] li').forEach((li) => {
      const inp = li.querySelector('input');
      const t = li.querySelector('.facet-checkbox__text');
      if (t && /\(0\)\s*$/.test(t.textContent.trim()) && !(inp && inp.checked)) li.hidden = true;
    });
    racine.querySelectorAll('[id^="Wrap-Filter-couleur"] label, [id^="Wrap-Filter-color"] label').forEach((l) => {
      // déjà posée là où on la poserait : rien (passe 13 : sans libellé .facet-checkbox__text, la pastille posée sur le label
      // n'était pas vue et l'observateur en reposait une toutes les 60 ms)
      if (l.querySelector('.facet-checkbox__text .vs-fpastille')
        || (!l.querySelector('.facet-checkbox__text') && l.querySelector(':scope > .vs-fpastille'))) return;
      l.querySelectorAll('.input-check-mark .vs-fpastille').forEach((x) => x.remove());
      const brut = [...l.childNodes].map((n) => n.textContent).join(' ');
      const nom = plat(brut.replace(/\s+/g, ' '));
      // passe 14 (04/11) : filtre du métachamp de catégorie « Couleur » : Shopify pose sa pastille ; on n'en ajoute pas une
      // seconde (doublon sur ordinateur), et « Multicolore », la seule sans couleur, reçoit le disque des motifs
      const native = l.querySelector('.swatch');
      if (native) {
        if (/^multicolore/.test(nom) && !native.style.getPropertyValue('--swatch--background').trim()) native.classList.add('vs-fpastille--motif');
        return;
      }
      const cle = Object.keys(TEINTES).sort((a, b) => b.length - a.length).find((k) => nom === k || nom.startsWith(k + ' ') || nom.startsWith(k));
      const s = document.createElement('span');
      s.className = 'vs-fpastille' + (cle ? '' : ' vs-fpastille--motif');
      s.setAttribute('aria-hidden', 'true');
      if (cle) s.style.setProperty('--vs-fp', TEINTES[cle]);
      const cible = l.querySelector('.facet-checkbox__text') || l;
      cible.prepend(s);
    });
  }
  function tranches(racine) {
    const col = racine.querySelector('[id^="Wrap-Filter-prix"], [id^="Wrap-Filter-price"]');
    const panneau = col && col.querySelector('.facets__display');
    if (!panneau || panneau.querySelector('.vs-ftranches')) return;
    const p = new URLSearchParams(location.search);
    const gte = p.get('filter.v.price.gte'), lte = p.get('filter.v.price.lte');
    const T = [['Moins de 40 €', null, '40'], ['40 à 80 €', '40', '80'], ['80 € et plus', '80', null]];
    const nav = document.createElement('div'); nav.className = 'vs-ftranches';
    T.forEach(([lib, a, b]) => {
      const q = new URLSearchParams(location.search);
      q.delete('filter.v.price.gte'); q.delete('filter.v.price.lte'); q.delete('page');
      if (a) q.set('filter.v.price.gte', a); if (b) q.set('filter.v.price.lte', b);
      const lien = document.createElement('a'); lien.href = location.pathname + '?' + q.toString(); lien.textContent = lib;
      if ((gte || null) === a && (lte || null) === b) lien.setAttribute('aria-current', 'true');
      nav.appendChild(lien);
    });
    panneau.prepend(nav);
  }
  const zone = document.getElementById('main-collection-filters') || document.querySelector('.facets-container');
  if (!zone) return;
  const go = () => { pastilles(document); tranches(document); };
  go();
  let attente = null;
  new MutationObserver(() => { clearTimeout(attente); attente = setTimeout(go, 60); }).observe(zone.parentElement || zone, { childList: true, subtree: true });
})();

/* Halezia, passe 9 (29/10/2026) : choix de la taille sur la fiche (demande de Solal : gagner de la place, bouton d'ajout
   plus haut). Baymard : des boutons pour quelques choix, une liste au-delà. Ici :
   - tailles en cm rangées de la plus petite à la plus grande surface (les données les donnent dans le désordre) ;
   - plus de 6 tailles : un menu déroulant remplace la grille de boutons (les boutons de Honey restent dans la page, masqués :
     la variante, le conseil de taille et le verdict sous les tailles continuent de les lire) ; une taille épuisée reste
     dans la liste, marquée « épuisé ».
   Rejoué quand Honey redessine le sélecteur (changement de couleur). */
(() => {
  const SEUIL = 6;
  const surface = (v) => {
    const m = String(v).toLowerCase().replace(/×/g, 'x').match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/);
    return m ? parseFloat(m[1].replace(',', '.')) * parseFloat(m[2].replace(',', '.')) : null;
  };
  function monter(fs) {
    const boite = fs.querySelector('.single-option-selector--box');
    if (!boite) return;
    const radios = [...boite.querySelectorAll('input[type="radio"]')];
    if (!radios.length || !/^taille/i.test(radios[0].name || '')) return;
    const tri = radios.map((i) => ({ i, s: surface(i.value) }));
    if (tri.some((x) => x.s === null)) return;           // tailles en lettres (sweats) : on ne touche à rien
    tri.sort((a, b) => a.s - b.s);
    // ordre visuel des boutons (la grille est en flex)
    tri.forEach((x, k) => { const w = x.i.closest('.single-option-selector__wrap-option'); if (w) w.style.order = k; });
    if (radios.length <= SEUIL) return;
    fs.classList.add('vs-tsel-actif');
    let zone = fs.querySelector('.vs-tsel');
    if (!zone) {
      zone = document.createElement('div'); zone.className = 'vs-tsel';
      const sel = document.createElement('select'); sel.className = 'vs-tsel__select';
      sel.setAttribute('aria-label', 'Taille');
      sel.addEventListener('change', (e) => {
        e.stopPropagation();                         // sinon variants.js de Honey le prend pour son propre menu et plante
        const r = radios.find((i) => i.value === sel.value) || [...fs.querySelectorAll('input[type="radio"]')].find((i) => i.value === sel.value);
        if (r && !r.checked) r.click();               // le clic coche et déclenche le changement de variante de Honey
      });
      zone.appendChild(sel);
      boite.before(zone);
    }
    const sel = zone.querySelector('select');
    // signature : sans elle, la reconstruction de la liste relance l'observateur à l'infini
    const sig = tri.map(({ i }) => i.value + (i.checked ? '*' : '') + (i.dataset.disabled === 'true' ? '!' : '')).join('|');
    if (zone.dataset.sig === sig) return;
    zone.dataset.sig = sig;
    sel.replaceChildren(...tri.map(({ i }) => {
      const o = document.createElement('option');
      o.value = i.value;
      o.textContent = i.value.replace(/\s*cm\s*$/i, ' cm').replace(/(\d)\s*x\s*(\d)/i, '$1 x $2') + (i.dataset.disabled === 'true' ? ' (épuisé)' : '');
      if (i.checked) o.selected = true;
      return o;
    }));
  }
  const go = () => document.querySelectorAll('variant-selects fieldset').forEach(monter);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  // Honey remplace tout le bloc des variantes à chaque choix : on observe la section entière (la signature évite les boucles)
  const zoneFiche = document.querySelector('.product-section') || document.querySelector('product-information');
  if (zoneFiche && 'MutationObserver' in window) {
    let t = null;
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(go, 40); }).observe(zoneFiche, { childList: true, subtree: true });
  }
})();

/* Tiroir panier, passe 11 (paliers de l'offre) : remplacé à la passe 13 (02/11/2026) par js/90-vs13-panier.js (tiroir à nous). */

/* Halezia, passe 12 (30/10/2026) : la collection.
   1. Choix de l'affichage (4 ou 2 colonnes ; mobile : 2 ou 1), gardé dans le navigateur ; l'attribut sizes des images
      suit, pour charger la bonne largeur.
   2. Nombre de plaids et progression de « Voir plus », relus sur le total filtré que la grille porte (data-vs-total) :
      facets.js redessine la grille sans toucher la barre, le nombre se mettait pas à jour.
   3. Entrée des cases au défilement (seulement celles encore sous l'écran ; rien de caché sans script).
   4. Ombre de la barre des filtres quand elle est collée.
   5. Texte de la collection replié, « Lire la suite » (le texte reste dans la page).
   6. Flèches de « Les autres rayons ». */
(() => {
  if (!document.getElementById('ProductGridContainer')) return;
  const html = document.documentElement;
  const reduit = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const grille = () => document.querySelector('#ProductGridContainer .product-grid');

  // 1. Choix de l'affichage
  const CLE = 'vs-vue-collection';
  const vue = document.querySelector('.vs-vue');
  let choix = 'serre';
  try { choix = localStorage.getItem(CLE) === 'large' ? 'large' : 'serre'; } catch (e) { /* stockage indisponible */ }
  const TAILLE_LARGE = '(min-width: 750px) calc((100vw - 56px) / 2), calc(100vw - 32px)';
  function tailles() {
    const large = html.classList.contains('vs-vue-large');
    document.querySelectorAll('#ProductGridContainer .vs-carte__img').forEach((i) => {
      if (!i.dataset.vsSizes) i.dataset.vsSizes = i.getAttribute('sizes') || '';
      const s = large ? TAILLE_LARGE : i.dataset.vsSizes;
      if (s && i.getAttribute('sizes') !== s) i.setAttribute('sizes', s);
    });
  }
  function appliquer(v) {
    html.classList.toggle('vs-vue-large', v === 'large');
    if (vue) vue.querySelectorAll('[data-vs-vue]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.vsVue === v)));
    tailles();
  }
  if (vue) {
    vue.hidden = false;
    vue.addEventListener('click', (e) => {
      const b = e.target.closest('[data-vs-vue]');
      if (!b || b.dataset.vsVue === choix) return;
      choix = b.dataset.vsVue;
      try { localStorage.setItem(CLE, choix); } catch (er) { /* rien */ }
      appliquer(choix);
    });
  }
  appliquer(choix);

  // 2. Nombre de plaids et progression
  function majCompte() {
    const t = document.querySelector('#ProductGridContainer [data-vs-total]');
    if (!t) return;
    const n = parseInt(t.dataset.vsTotal, 10);
    if (!(n >= 0)) return;
    const txt = n + (n > 1 ? ' plaids' : ' plaid');
    document.querySelectorAll('#main-collection-filters .vs-compte, [data-vs-compte]').forEach((e) => { if (e.textContent !== txt) e.textContent = txt; });
    const charge = document.querySelector('#component-pagination-loader pagination-loader');
    const btn = charge && charge.querySelector('.js-load-more');
    let p = charge && charge.querySelector('.vs12-progres');
    const vus = Math.min(n, document.querySelectorAll('#ProductGridContainer .product-grid > .data-pagination__item').length
      + (document.querySelector('#ProductGridContainer .vs-tuile') ? 1 : 0));
    if (!charge || !btn || btn.classList.contains('hide') || vus >= n) { if (p) p.hidden = true; return; }
    if (!p) {
      p = document.createElement('div');
      p.className = 'vs12-progres';
      p.innerHTML = '<p class="vs12-progres__texte"></p><span class="vs12-progres__barre" aria-hidden="true"><span></span></span>';
      const wrap = charge.querySelector('.load-more_wrap');
      (wrap || btn).before(p);
    }
    p.hidden = false;
    // écrit seulement si le texte change : la barre est dans #ProductGridContainer, que l'observateur du bas surveille ;
    // une écriture à chaque passage relançait l'observateur toutes les 80 ms sans fin (passe 13, 02/11 : 6,3 s de script
    // de vs-refonte.js sur la collection dans Lighthouse, passe 12)
    const tx = p.querySelector('.vs12-progres__texte'), nt = vus + ' plaids sur ' + n;
    if (tx.textContent !== nt) tx.textContent = nt;
    p.querySelector('.vs12-progres__barre > span').style.setProperty('--vs12-p', String(vus / n));
  }

  // 3. Entrée des cases
  const io = !reduit && 'IntersectionObserver' in window ? new IntersectionObserver((es) => {
    es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-vu'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px' }) : null;
  function entrees() {
    const g = grille();
    if (!io || !g) return;
    const cols = Math.max(1, getComputedStyle(g).gridTemplateColumns.split(' ').length);
    let i = 0;
    for (const li of g.children) {
      if (li.hidden || li.dataset.vsE) { if (!li.hidden) i++; continue; }
      li.dataset.vsE = '1';
      const r = li.getBoundingClientRect();
      if (r.top < innerHeight) { i++; continue; }
      li.style.setProperty('--vs12-d', ((i % cols) * 70) + 'ms');
      li.classList.add('vs12-attente');
      io.observe(li);
      i++;
    }
  }

  let attente = null;
  const tout = () => { majCompte(); tailles(); entrees(); };
  new MutationObserver(() => { clearTimeout(attente); attente = setTimeout(tout, 80); })
    .observe(document.getElementById('ProductGridContainer'), { childList: true, subtree: true });
  tout();

  // 4. Barre collée
  const barre = document.getElementById('main-collection-filters');
  if (barre && 'IntersectionObserver' in window) {
    const s = document.createElement('div');
    s.className = 'vs12-sentinelle'; s.setAttribute('aria-hidden', 'true');
    barre.before(s);
    new IntersectionObserver(([e]) => barre.classList.toggle('is-colle', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(s);
  }

  // 5. Texte de la collection replié
  document.querySelectorAll('.template-collection .rich-text-section .rte').forEach((rte) => {
    if (rte.classList.contains('vs12-seo') || rte.scrollHeight < 620) return;
    rte.classList.add('vs12-seo', 'vs12-seo--plie');
    rte.id = rte.id || 'vs12-seo-texte';
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'vs12-seo__suite'; b.textContent = 'Lire la suite';
    b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', rte.id);
    b.addEventListener('click', () => {
      const plie = rte.classList.toggle('vs12-seo--plie');
      b.textContent = plie ? 'Lire la suite' : 'Réduire';
      b.setAttribute('aria-expanded', String(!plie));
      if (plie) {
        const sec = rte.closest('.rich-text-section') || rte;
        if (sec.getBoundingClientRect().top < 0) sec.scrollIntoView({ block: 'start', behavior: reduit ? 'auto' : 'smooth' });
      }
    });
    rte.after(b);
  });

  // 5 bis. Raccourcis : le rail (mobile) se cale sur le rayon courant
  const racCour = document.querySelector('.vs-rac [aria-current="page"]');
  const rac = racCour && racCour.closest('.vs-rac');
  if (rac && rac.scrollWidth > rac.clientWidth + 2) {
    const li = racCour.closest('li') || racCour;
    rac.scrollLeft = Math.max(0, li.offsetLeft - rac.offsetLeft - (rac.clientWidth - li.offsetWidth) / 2);
  }

  // 6. Les autres rayons
  document.querySelectorAll('.vs12-rayons').forEach((sec) => {
    const rail = sec.querySelector('.vs12-rayons__rail');
    const fl = sec.querySelector('.vs12-rayons__fleches');
    if (!rail || !fl) return;
    const prec = fl.querySelector('[data-vs-dir="-1"]'), suiv = fl.querySelector('[data-vs-dir="1"]');
    const maj = () => {
      const max = rail.scrollWidth - rail.clientWidth - 2;
      fl.hidden = max <= 0;
      prec.disabled = rail.scrollLeft <= 2;
      suiv.disabled = rail.scrollLeft >= max;
    };
    fl.addEventListener('click', (e) => {
      const b = e.target.closest('[data-vs-dir]');
      if (!b || b.disabled) return;
      const it = rail.querySelector('li');
      const pas = it ? it.getBoundingClientRect().width + 8 : 320;
      rail.scrollBy({ left: Number(b.dataset.vsDir) * pas * 2, behavior: reduit ? 'auto' : 'smooth' });
    });
    let rf = 0;
    rail.addEventListener('scroll', () => { cancelAnimationFrame(rf); rf = requestAnimationFrame(maj); }, { passive: true });
    addEventListener('resize', maj);
    maj();
  });
})();

/* Halezia, passe 12 (30/10/2026) : l'accueil. Curseur du froid, rail de l'atelier, trouveur de cadeau, entrées des
   panneaux. Chaque bloc ne fait rien si sa section est absente. Sans script, chaque section reste lisible et cliquable. */
(function () {
  'use strict';
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Curseur « Quel plaid pour quel froid ? » ---------- */
  document.querySelectorAll('[data-vs12-froid]').forEach(function (sec) {
    var curseur = sec.querySelector('.vs12-froid__curseur');
    var imgs = sec.querySelectorAll('.vs12-froid__img');
    var fiches = sec.querySelectorAll('.vs12-froid__fiche');
    var crans = sec.querySelectorAll('.vs12-froid__cran');
    if (!curseur) return;
    function aller(n) {
      n = Math.max(0, Math.min(crans.length - 1, n));
      curseur.value = n;
      sec.dataset.cran = n;
      sec.classList.toggle('is-nuit', n >= 3);
      imgs.forEach(function (im, i) {
        im.classList.toggle('is-actif', i === n);
        if (i === n) im.removeAttribute('aria-hidden'); else im.setAttribute('aria-hidden', 'true');
        if (Math.abs(i - n) <= 1) im.loading = 'eager';
      });
      fiches.forEach(function (f, i) { f.hidden = i !== n; f.classList.toggle('is-actif', i === n); });
      crans.forEach(function (b, i) { b.classList.toggle('is-actif', i === n); b.setAttribute('aria-pressed', i === n ? 'true' : 'false'); });
      curseur.setAttribute('aria-valuetext', crans[n].textContent.trim());
    }
    curseur.addEventListener('input', function () { aller(parseInt(curseur.value, 10)); });
    crans.forEach(function (b) { b.addEventListener('click', function () { aller(parseInt(b.dataset.cran, 10)); }); });
    /* passe 13 (grille, N6) : de novembre à février, le curseur s'ouvre sur « Crépuscule d'hiver » (4e cran), pas sur un
       soir de juillet */
    var mois = new Date().getMonth();
    if ((mois >= 10 || mois <= 1) && crans.length > 3) aller(3);
    /* l'image suivante se charge dès que la section approche */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { if (imgs[1]) imgs[1].loading = 'eager'; io.disconnect(); } });
      }, { rootMargin: '400px 0px' });
      io.observe(sec);
    }
  });

  /* ---------- Rail de l'atelier ---------- */
  document.querySelectorAll('[data-vs12-atelier]').forEach(function (sec) {
    var rail = sec.querySelector('.vs12-atelier__rail');
    var fl = sec.querySelectorAll('.vs12-atelier__fleche');
    if (!rail || fl.length < 2) return;
    function etat() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      fl[0].disabled = rail.scrollLeft <= 2;
      fl[1].disabled = rail.scrollLeft >= max;
    }
    fl.forEach(function (b) {
      b.addEventListener('click', function () {
        var it = rail.querySelector('.vs12-atelier__item');
        var pas = it ? it.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : rail.clientWidth * 0.8;
        rail.scrollBy({ left: pas * 2 * parseInt(b.dataset.sens, 10), behavior: reduit ? 'auto' : 'smooth' });
      });
    });
    rail.addEventListener('scroll', etat, { passive: true });
    window.addEventListener('resize', etat);
    etat();
  });

  /* ---------- Trouveur de cadeau ---------- */
  var POOLS = {
    adulte: { doux: ['plaid-fourrure', 'plaid-polaire'], deco: ['plaid-grosse-maille', 'plaid-tricot'], porte: ['sweat-plaid'] },
    enfant: { doux: ['plaid-enfant'], deco: ['plaid-enfant'], porte: ['sweat-plaid'] },
    bebe: { doux: ['plaid-bebe'], deco: ['plaid-bebe'], porte: ['plaid-bebe'] }
  };
  document.querySelectorAll('[data-vs12-cad]').forEach(function (sec) {
    var form = sec.querySelector('.vs12-cad__questions');
    var items = Array.prototype.slice.call(sec.querySelectorAll('.vs12-cad__item'));
    var tout = sec.querySelector('[data-vs12-cad-tout]');
    if (!form || !items.length) return;
    function val(n) { var r = form.querySelector('input[name="vs12-' + n + '"]:checked'); return r ? r.value : ''; }
    function choisir() {
      var qui = val('qui'), envie = val('envie'), b = val('budget').split('-');
      var bas = +b[0], haut = +b[1];
      var bebe = qui === 'bebe';
      form.querySelectorAll('input[name="vs12-envie"]').forEach(function (r) { r.disabled = bebe; });
      sec.querySelector('[data-q="envie"]').classList.toggle('is-inactif', bebe);
      var pools = POOLS[qui][envie] || POOLS.adulte.doux;
      var vus = {}, cands = [];
      items.forEach(function (li) {
        if (pools.indexOf(li.dataset.pool) < 0 || vus[li.dataset.handle]) return;
        vus[li.dataset.handle] = 1; cands.push(li);
      });
      var dans = cands.filter(function (li) { var p = +li.dataset.prix; return p >= bas && p < haut; });
      if (dans.length < 3) {   /* pas assez dans le budget : les plus proches du budget complètent */
        var milieu = (bas + Math.min(haut, 20000)) / 2;
        var reste = cands.filter(function (li) { return dans.indexOf(li) < 0; })
          .sort(function (a, c) { return Math.abs(+a.dataset.prix - milieu) - Math.abs(+c.dataset.prix - milieu); });
        dans = dans.concat(reste).slice(0, 3);
      }
      var choix = dans.slice(0, 3);
      items.forEach(function (li) { li.hidden = choix.indexOf(li) < 0; li.style.order = choix.indexOf(li); });
      choix.forEach(function (li, i) {
        if (reduit) return;
        li.animate([{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }],
          { duration: 320, delay: i * 70, easing: 'cubic-bezier(0.23, 1, 0.32, 1)', fill: 'backwards' });
      });
      if (tout) tout.href = '/collections/' + pools[0];
    }
    form.addEventListener('change', choisir);
    choisir();
  });

  /* ---------- Entrées (panneaux, titres de section) : une fois, à l'entrée dans l'écran ---------- */
  var cibles = document.querySelectorAll('.vs12-pan__item, [data-vs12-entree]');
  if (cibles.length && 'IntersectionObserver' in window && !reduit) {
    document.documentElement.classList.add('vs12-anime');
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-vu'); io2.unobserve(e.target); } });
    }, { threshold: 0.25 });
    cibles.forEach(function (c) { io2.observe(c); });
  }
})();

/* Halezia, passe 12 (30/10/2026) : fiche produit (98-fiche-p12.css). Quatre gestes, tous sans effet si le balisage de
   Honey manque :
   1. le prix de la variante choisie dans le bouton d'ajout (« Ajouter au panier · 29,90 € »), comme Koala et Bonsoirs ;
   2. tailles en lettres (sweats plaid) : cases étroites (vs-pills-courtes) ;
   3. barre d'achat mobile : la vignette de la variante choisie à gauche du rappel (couleur, taille, prix) ;
   4. galerie : compteur « 3 / 13 » sur la photo (mobile) et visionneuse plein écran au clic sur la photo (vs-vis),
      toutes les photos en grand (le zoom au survol de Honey reste sur ordinateur).
   Honey redessine une partie du bloc d'achat après un changement de variante (PUB_SUB_EVENTS.variantChange) : on repose. */
(function () {
  var meta = document.querySelector('.product-section .product-single__meta');
  if (!meta) return;

  function euros(c) {
    try { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function variante() {
    var s = meta.querySelector('script[data-selected-variant]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function boutonPrincipal() {
    return Array.prototype.find.call(meta.querySelectorAll('button[data-add-to-cart]'), function (b) { return !b.closest('.product-form__button--fixed'); });
  }

  /* 1. Prix dans le bouton ; passe 14 (04/11) : aussi dans le bouton de la barre mobile (« Ajouter au panier · 29,90 € »,
     masqué sur ordinateur par 98-fiche-p12.css) */
  function poserPrix(v) {
    if (!v) return;
    var bs = [boutonPrincipal(), meta.querySelector('.product-form__cart-submit--fixed')];
    bs.forEach(function (b) {
      var zone = b && b.querySelector('.product-form__cart-submit-text');
      if (!zone) return;
      var s = zone.querySelector('.vs-btn-prix');
      if (!s) { s = document.createElement('span'); s.className = 'vs-btn-prix'; zone.appendChild(s); }
      s.textContent = euros(v.price);
    });
  }

  /* 2. Tailles en lettres */
  function pillsCourtes() {
    meta.querySelectorAll('.product-meta-option--pill').forEach(function (f) {
      var t = Array.prototype.map.call(f.querySelectorAll('.single-option-selector__option__text'), function (x) { return x.textContent.trim(); });
      f.classList.toggle('vs-pills-courtes', t.length > 0 && t.every(function (x) { return x.length <= 4; }));
    });
  }

  /* 3. Vignette dans la barre mobile */
  function srcLargeur(src, w) {
    if (!src) return '';
    return src.replace(/([?&])width=\d+/, '$1') + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function poserVignette(v) {
    var c = meta.querySelector('.product-form__button--fixed .product-form__button--fixed__content');
    if (!c) return;
    var src = (v && v.featured_image && v.featured_image.src) || '';
    if (!src) { var i0 = document.querySelector('.product-section .product-single__gallery .slick-slide:not(.slick-cloned) img'); src = i0 ? (i0.currentSrc || i0.src) : ''; }
    if (!src) return;
    var img = c.querySelector('.vs-barre__vign');
    if (!img) {
      img = document.createElement('img');
      img.className = 'vs-barre__vign'; img.alt = ''; img.width = 44; img.height = 44; img.setAttribute('aria-hidden', 'true');
      var choix = c.querySelector('.vs-barre__choix');
      c.insertBefore(img, choix || c.firstChild);
    }
    var nouveau = srcLargeur(src, 120);
    if (img.getAttribute('src') !== nouveau) img.src = nouveau;
  }

  /* 3 bis. Barre sur ordinateur (quand la colonne d'achat a quitté l'écran) et état « Choisir ma taille » sur mobile.
     Passe 14 (04/11/2026, Solal) : sur mobile, la barre n'apparaît qu'une fois le bouton principal passé au-dessus de
     l'écran (même règle que 00-passes-2-a-4.js) ; « Choisir ma taille » tant que le client n'a touché aucune taille
     (Honey coche la première d'office), quel que soit l'endroit de la page ; le tap remonte au bloc des tailles. */
  var mqMob = window.matchMedia('(max-width: 1000px)');
  var tailleChoisie = false;
  function groupeForm() { return meta.querySelector('[data-controls-group-submit]'); }
  /* le bloc des tailles : boutons dont le nom d'option dit la taille (« options[Taille] », Size, Longueur) */
  function fsTaille() {
    var l = meta.querySelectorAll('.product-meta-option--pill');
    for (var k = 0; k < l.length; k++) {
      var i = l[k].querySelector('input[type="radio"]');
      if (i && /taille|size|longueur/i.test(i.name || '')) return l[k];
    }
    return null;
  }
  function poserNom() {
    var c = meta.querySelector('.product-form__button--fixed .vs-barre__choix');
    var h1 = document.querySelector('.product-section h1');
    if (!c || !h1 || c.querySelector('.vs-barre__nom')) return;
    var n = document.createElement('span'); n.className = 'vs-barre__nom'; n.textContent = h1.textContent.trim();
    c.insertBefore(n, c.firstChild);
  }
  function etatBarres() {
    var g = groupeForm(), b = boutonPrincipal();
    if (!g || !b) return;
    var r = b.getBoundingClientRect();
    var horsEcran = r.bottom < 0 || r.top > window.innerHeight;
    /* la barre d'ordinateur s'efface sur le pied de page (elle cachait le titre de la lettre d'information) */
    var pied = document.querySelector('.vs-pied, [role="contentinfo"]');
    var surPied = !!pied && pied.getBoundingClientRect().top < window.innerHeight - 80;
    g.classList.toggle('vs-barre-ordi', !mqMob.matches && horsEcran && !surPied);
    if (mqMob.matches) g.classList.toggle('vs-barre-visible', r.bottom <= 0);
    var fb = g.querySelector('.product-form__cart-submit--fixed');
    if (!fb) return;
    var fs = fsTaille();
    var plusieurs = !!fs && fs.querySelectorAll('input[type="radio"]').length > 1;
    var choisir = mqMob.matches && plusieurs && !tailleChoisie;
    g.classList.toggle('vs-barre-choisir', choisir);
    var s = fb.querySelector('.vs-barre__choisir');
    if (!s) { s = document.createElement('span'); s.className = 'vs-barre__choisir'; s.textContent = 'Choisir ma taille'; fb.appendChild(s); }
    fb.setAttribute('aria-label', choisir ? 'Choisir ma taille' : 'Ajouter au panier');
  }
  /* une taille touchée (boutons, menu des tailles, ou format du studio « Trouver ma taille », même celui déjà coché) :
     la barre devient « Ajouter au panier · prix » */
  function touchee(e) {
    var fs = fsTaille(), t = e.target;
    if (!fs || !t.closest || t.closest('.product-meta-option--pill') !== fs) return;
    if (e.type === 'click' && !t.closest('input[type="radio"], label')) return;   /* « Trouver ma taille » n'est pas un choix */
    tailleChoisie = true; planifier();
  }
  meta.addEventListener('change', touchee);
  meta.addEventListener('click', touchee);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-vs-format]')) { tailleChoisie = true; planifier(); } });
  var attenteBarre = 0;
  function planifier() { if (!attenteBarre) attenteBarre = requestAnimationFrame(function () { attenteBarre = 0; etatBarres(); }); }
  window.addEventListener('scroll', planifier, { passive: true });
  window.addEventListener('resize', planifier);
  document.addEventListener('click', function (e) {
    var fb = e.target.closest && e.target.closest('.product-form__cart-submit--fixed');
    var g = groupeForm();
    if (!fb || !g || !g.classList.contains('vs-barre-choisir')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fs = fsTaille();
    if (!fs) return;
    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: fs.getBoundingClientRect().top + window.scrollY - 120, behavior: reduit ? 'auto' : 'smooth' });
    fs.classList.remove('vs-repere'); void fs.offsetWidth; fs.classList.add('vs-repere');
    var r = fs.querySelector('input[type="radio"]:checked') || fs.querySelector('input[type="radio"]');
    if (r) setTimeout(function () { try { r.focus({ preventScroll: true }); } catch (x) {} }, reduit ? 0 : 450);
  }, true);

  function tout(v) { v = v || variante(); poserPrix(v); pillsCourtes(); poserVignette(v); poserNom(); etatBarres(); }
  tout();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      var v = ev && ev.data && ev.data.variant;
      setTimeout(function () { tout(v); }, 120);
    });
  }
  /* la barre mobile peut être posée par 00-passes-2-a-4.js après nous : un second passage au chargement complet */
  window.addEventListener('load', function () { poserVignette(variante()); poserNom(); etatBarres(); });

  /* 4. Galerie : compteur et visionneuse */
  var galerie = document.querySelector('.product-section .product-single__gallery');
  if (!galerie) return;
  function slides() { return Array.prototype.filter.call(galerie.querySelectorAll('.slick-slide'), function (s) { return !s.classList.contains('slick-cloned'); }); }
  function photos() {
    var vues = [], deja = {};
    slides().forEach(function (s) {
      var z = s.querySelector('[data-zoom]');
      var im = s.querySelector('img');
      if (!z || !im) return;
      var url = z.getAttribute('data-zoom');
      if (deja[url]) return;
      deja[url] = 1;
      vues.push({ url: url, alt: im.getAttribute('alt') || '', w: im.getAttribute('width') || im.naturalWidth, h: im.getAttribute('height') || im.naturalHeight });
    });
    return vues;
  }

  /* vignette active dès l'arrivée (Honey ne la marque qu'au premier changement de photo) */
  var vigns = document.querySelectorAll('.product-section .product-single__thumbnails-item:not(.product-single__thumbnails--hide) .product-single__thumbnail');
  if (vigns.length && !document.querySelector('.product-section .product-single__thumbnail.active-thumb')) {
    vigns[0].classList.add('active-thumb'); vigns[0].setAttribute('aria-current', 'true');
  }
  var groupe = galerie.closest('.product-single__media-group__wrap') || galerie.parentNode;
  var compte = document.createElement('span');
  compte.className = 'vs-galcompte'; compte.setAttribute('aria-hidden', 'true');
  function majCompte() {
    var s = slides(), cur = galerie.querySelector('.slick-current:not(.slick-cloned)');
    var i = Math.max(0, s.indexOf(cur));
    compte.textContent = (i + 1) + ' / ' + s.length;
    compte.hidden = s.length < 2;
  }
  var porteur = galerie.closest('.product-single__wrapper') || groupe;
  porteur.appendChild(compte);
  majCompte();
  if ('MutationObserver' in window) new MutationObserver(function () { majCompte(); }).observe(galerie, { subtree: true, attributes: true, attributeFilter: ['class'] });

  var dlg = null, liste = null, compteur = null, io = null;
  var SVG_X = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  function construire(vues) {
    dlg = document.createElement('dialog');
    dlg.className = 'vs-vis';
    dlg.setAttribute('aria-label', 'Photos du produit');
    dlg.innerHTML = '<div class="vs-vis__barre"><span class="vs-vis__compteur" aria-live="polite"></span>' +
      '<button type="button" class="vs-vis__fermer" aria-label="Fermer les photos">' + SVG_X + '</button></div><ol class="vs-vis__liste" role="list"></ol>';
    liste = dlg.querySelector('.vs-vis__liste');
    compteur = dlg.querySelector('.vs-vis__compteur');
    vues.forEach(function (v, i) {
      var li = document.createElement('li');
      var im = document.createElement('img');
      im.alt = v.alt; im.decoding = 'async'; im.loading = 'lazy';
      if (v.w && v.h) { im.width = v.w; im.height = v.h; }   /* proportions réservées : le compteur suit la bonne photo */
      im.sizes = '(max-width: 749px) 100vw, min(1100px, 100vw)';
      im.srcset = [800, 1200, 1600, 2000].map(function (w) { return srcLargeur(v.url, w) + ' ' + w + 'w'; }).join(', ');
      im.src = srcLargeur(v.url, 1200);
      li.setAttribute('data-i', i);
      li.appendChild(im);
      liste.appendChild(li);
    });
    dlg.querySelector('.vs-vis__fermer').addEventListener('click', function () { dlg.close(); });
    liste.addEventListener('click', function (e) { if (e.target.tagName === 'IMG' && window.matchMedia('(min-width: 750px)').matches) dlg.close(); });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('vs-vis-ouverte'); });
    document.body.appendChild(dlg);
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        var best = null;
        es.forEach(function (en) { if (en.isIntersecting && (!best || en.intersectionRatio > best.intersectionRatio)) best = en; });
        if (best) compteur.textContent = (+best.target.getAttribute('data-i') + 1) + ' / ' + vues.length;
      }, { root: liste, threshold: 0.55 });
      liste.querySelectorAll('li').forEach(function (li) { io.observe(li); });
    }
  }
  function ouvrir(index) {
    var vues = photos();
    if (!vues.length) return;
    if (!dlg) construire(vues);
    if (typeof dlg.showModal !== 'function') return;
    var li = liste.querySelector('li[data-i="' + index + '"]');
    if (li) { var im = li.querySelector('img'); im.loading = 'eager'; }
    compteur.textContent = (index + 1) + ' / ' + vues.length;
    document.documentElement.classList.add('vs-vis-ouverte');
    dlg.showModal();
    if (li) {
      if (window.matchMedia('(max-width: 749px)').matches) liste.scrollLeft = li.offsetLeft;
      else liste.scrollTop = li.offsetTop - 72;
    }
  }
  galerie.addEventListener('click', function (e) {
    if (e.target.closest('.slick-arrow, button, a, video, model-viewer, .product-media-modal__model')) return;
    var s = e.target.closest('.slick-slide');
    if (!s) return;
    var z = s.querySelector('[data-zoom]');
    if (!z) return;
    var vues = photos(), url = z.getAttribute('data-zoom');
    var i = 0;
    vues.forEach(function (v, k) { if (v.url === url) i = k; });
    ouvrir(i);
  });
})();

/* Tiroir panier, passe 12 (ligne neuve animée) : remplacé à la passe 13 (02/11/2026) par js/90-vs13-panier.js (tiroir à nous). */

/* Halezia, passe 13 (02/11/2026) : le menu, composant à nous (snippets vs13-nav et vs13-tiroir, feuille 99-menu-p13.css).
   Méga menu (990 px et plus) : ouverture au survol avec intention (140 ms), passage d'une rubrique à l'autre sans
   attente (70 ms), fermeture avec un délai de grâce (260 ms) ; clic et clavier (Entrée, Espace, flèche bas, Échap) ;
   aria-expanded ; photos chargées au premier survol de la barre. Menu mobile : <dialog> modal (focus piégé, fond
   inerte), Échap, second niveau qui glisse, retour du focus au bouton. Sans script : le méga menu s'ouvre au survol
   (CSS, .no-js) ; tout le reste du site est inchangé. */
(function () {
  'use strict';
  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  const large = window.matchMedia('(min-width: 990px)');

  /* Attend la fin d'une transition sur el (ou le délai, si la transition n'a pas lieu) */
  function apres(el, ms, fn) {
    let fait = false;
    const fin = () => { if (fait) return; fait = true; el.removeEventListener('transitionend', surFin); fn(); };
    const surFin = (e) => { if (e.target === el) fin(); };
    el.addEventListener('transitionend', surFin);
    setTimeout(fin, (reduit.matches ? 0 : ms) + 40);
  }

  /* ================================ Méga menu ================================ */
  const nav = document.querySelector('[data-vs13-nav]');
  if (nav) {
    const enTete = nav.closest('.header-wrapper') || nav.parentElement;
    const section = nav.closest('.shopify-section-header');
    const fond = nav.querySelector('[data-vs13-fond]');
    const voile = nav.querySelector('[data-vs13-voile]');
    const trait = nav.querySelector('[data-vs13-trait]');
    const items = Array.from(nav.querySelectorAll('.vs13-barre__item'));
    const courant = nav.querySelector('.vs13-barre__lien.is-courant, .vs13-barre__lien[aria-current="page"]');
    const HAUT_FOND = 1000;
    let ouvert = null, ouvertA = 0, tOuvrir = 0, tFermer = 0, yOuvert = 0, dernierPointeur = '';

    const panneauDe = (b) => document.getElementById(b.getAttribute('aria-controls'));

    const charger = (p) => {
      if (!p || p.dataset.vs13Charge) return;
      p.dataset.vs13Charge = '1';
      p.querySelectorAll('img[data-vs13-src]').forEach((img) => {
        if (img.dataset.vs13Srcset) img.srcset = img.dataset.vs13Srcset;
        img.src = img.dataset.vs13Src;
      });
    };

    /* Le trait : sous le texte de la rubrique (mesuré sur le texte, pas sur la cible de 44 px) */
    const placerTrait = (lien, glisse) => {
      if (!trait) return;
      if (!lien) { trait.classList.remove('is-visible'); return; }
      const r = document.createRange();
      r.selectNodeContents(lien);
      const t = r.getBoundingClientRect(), e = enTete.getBoundingClientRect();
      if (!t.width) return;
      trait.classList.toggle('is-glisse', !!glisse && trait.classList.contains('is-visible') && !reduit.matches);
      trait.style.setProperty('--x', (t.left - e.left).toFixed(1) + 'px');
      trait.style.setProperty('--y', Math.round(t.bottom - e.top + 5) + 'px');
      trait.style.setProperty('--s', (t.width / 100).toFixed(4));
      trait.classList.add('is-visible');
    };
    const traitAuRepos = () => placerTrait(ouvert || courant, true);

    /* L'aperçu : la scène du lien survolé (ou du premier lien), sa teinte en fond pendant le chargement, son heure */
    const apercu = (p, cle) => {
      const a = p.querySelector('[data-vs13-apercu]');
      if (!a) return;
      const img = a.querySelector('img[data-vs13-cle="' + (cle || a.dataset.vs13Defaut) + '"]') || a.querySelector('img[data-vs13-cle]');
      if (!img || img.classList.contains('is-actif')) return;
      a.querySelectorAll('img.is-actif').forEach((i) => i.classList.remove('is-actif'));
      img.classList.add('is-actif');
      a.querySelector('.vs13-apercu__cadre').style.setProperty('--teinte', img.dataset.teinte || '');
      const lien = p.querySelector('.vs13-lien[data-vs13-cle="' + img.dataset.vs13Cle + '"]');
      const leg = a.querySelector('[data-vs13-legende]');
      if (leg) leg.textContent = (lien && lien.dataset.vs13Heure) || '';
    };

    const ouvrir = (b) => {
      clearTimeout(tOuvrir); clearTimeout(tFermer);
      if (ouvert === b) return;
      const p = panneauDe(b);
      if (!p) return;
      charger(p);
      const bascule = !!ouvert;
      if (ouvert) {
        const ancien = panneauDe(ouvert);
        ancien.classList.remove('is-ouvert'); ancien.hidden = true;
        ouvert.setAttribute('aria-expanded', 'false');
      }
      nav.classList.toggle('is-bascule', bascule);
      ouvert = b; ouvertA = Date.now(); yOuvert = window.scrollY;
      b.setAttribute('aria-expanded', 'true');
      document.documentElement.style.setProperty('--vs13-haut', Math.round(enTete.getBoundingClientRect().bottom) + 'px');
      p.hidden = false;
      const actuel = p.querySelector('.vs13-lien[aria-current="page"][data-vs13-cle]');
      apercu(p, actuel ? actuel.dataset.vs13Cle : '');
      fond.style.setProperty('--sy', (p.offsetHeight / HAUT_FOND).toFixed(4));
      void p.offsetWidth;
      p.classList.add('is-ouvert');
      fond.classList.add('is-ouvert');
      voile.classList.add('is-ouvert');
      enTete.classList.add('vs13-ouvert');
      if (section) section.classList.add('is-filled');
      placerTrait(b, bascule);
    };

    const fermer = (rendreFocus) => {
      clearTimeout(tOuvrir); clearTimeout(tFermer);
      if (!ouvert) return;
      const b = ouvert, p = panneauDe(b);
      ouvert = null;
      b.setAttribute('aria-expanded', 'false');
      p.classList.remove('is-ouvert');
      fond.classList.remove('is-ouvert');
      voile.classList.remove('is-ouvert');
      nav.classList.remove('is-bascule');
      placerTrait(courant, false);
      apres(fond, 200, () => {
        if (ouvert) return;
        p.hidden = true;
        enTete.classList.remove('vs13-ouvert');
        if (section) section.classList.remove('is-filled');
      });
      if (rendreFocus) b.focus();
    };

    items.forEach((li) => {
      const b = li.querySelector('[data-vs13-rubrique]');
      const lien = li.querySelector('.vs13-barre__lien');
      li.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(tFermer); clearTimeout(tOuvrir);
        if (!b) {
          /* rubrique sans panneau (Meilleures ventes) : le trait la suit, le panneau ouvert se referme */
          if (ouvert) tOuvrir = setTimeout(() => fermer(false), 120);
          placerTrait(lien, true);
          return;
        }
        charger(panneauDe(b));
        if (ouvert === b) return;
        if (!ouvert) placerTrait(lien, true);
        tOuvrir = setTimeout(() => ouvrir(b), ouvert ? 70 : 140);
      });
      li.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(tOuvrir);
        if (ouvert) tFermer = setTimeout(() => fermer(false), 260);
      });
      if (!b) return;
      b.addEventListener('pointerdown', (e) => { dernierPointeur = e.pointerType; });
      b.addEventListener('click', (e) => {
        /* un clic de souris sur une rubrique que le survol vient d'ouvrir la laisse ouverte */
        if (ouvert === b) {
          if (e.detail > 0 && dernierPointeur === 'mouse') return;
          fermer(false);
        } else {
          ouvrir(b);
        }
      });
      b.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          ouvrir(b);
          const premier = panneauDe(b).querySelector('a[href]');
          if (premier) premier.focus();
        }
      });
    });

    /* Le trait revient au repos (rubrique de la page, ou rien) quand la souris quitte toute la barre, pas à chaque
       rubrique : il ne repart pas en arrière entre deux rubriques voisines */
    const barre = nav.querySelector('.vs13-barre');
    barre.addEventListener('pointerleave', (e) => {
      if (e.pointerType === 'mouse' && !ouvert) traitAuRepos();
    });

    /* La barre au clavier : flèches gauche et droite d'une rubrique à l'autre */
    const liensBarre = Array.from(nav.querySelectorAll('.vs13-barre__lien'));
    liensBarre.forEach((l, i) => {
      l.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const n = liensBarre[(i + (e.key === 'ArrowRight' ? 1 : liensBarre.length - 1)) % liensBarre.length];
        if (ouvert && n.hasAttribute('data-vs13-rubrique')) ouvrir(n); else if (ouvert) fermer(false);
        n.focus();
      });
    });

    /* Aperçu au survol et au focus des liens */
    nav.querySelectorAll('.vs13-lien[data-vs13-cle]').forEach((l) => {
      const p = l.closest('[data-vs13-panneau]');
      const montrer = () => apercu(p, l.dataset.vs13Cle);
      l.addEventListener('pointerenter', montrer);
      l.addEventListener('focus', montrer);
    });

    /* Fermetures : Échap, focus sorti de la rubrique, clic dehors ou sur le voile, défilement, passage sous 990 px */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && ouvert) fermer(nav.contains(document.activeElement));
    });
    nav.addEventListener('focusout', (e) => {
      if (!ouvert) return;
      const li = ouvert.closest('.vs13-barre__item');
      if (e.relatedTarget && !li.contains(e.relatedTarget)) fermer(false);
    });
    document.addEventListener('pointerdown', (e) => {
      if (ouvert && (!nav.contains(e.target) || e.target === voile)) fermer(false);
    });
    voile.addEventListener('click', () => fermer(false));
    window.addEventListener('scroll', () => {
      if (ouvert && Math.abs(window.scrollY - yOuvert) > 80) fermer(false);
    }, { passive: true });
    large.addEventListener('change', () => { if (!large.matches) fermer(false); });
    window.addEventListener('resize', () => { if (!ouvert) placerTrait(courant, false); else placerTrait(ouvert, false); });
    const poser = () => placerTrait(courant, false);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(poser); else poser();
    window.addEventListener('load', poser);
  }

  /* ================================ Menu mobile ================================ */
  const tiroir = document.querySelector('[data-vs13-tiroir]');
  const bouton = document.querySelector('[data-vs13-ouvrir]');
  if (tiroir && bouton && typeof tiroir.showModal === 'function') {
    const feuille = tiroir.querySelector('[data-vs13-feuille]');
    const niveaux = tiroir.querySelector('[data-vs13-niveaux]');
    const n1 = tiroir.querySelector('[data-vs13-niveau="0"]');
    let n2 = null;

    const retour = (instant) => {
      if (!n2) return;
      const { b, cible } = n2;
      n2 = null;
      n1.inert = false;
      niveaux.classList.remove('is-n2');
      cible.classList.remove('is-actif');
      b.setAttribute('aria-expanded', 'false');
      if (instant) { cible.hidden = true; return; }
      apres(cible, 260, () => { if (!n2 || n2.cible !== cible) cible.hidden = true; });
      b.focus({ preventScroll: true });
    };

    const aller = (b) => {
      const cible = document.getElementById(b.getAttribute('aria-controls'));
      if (!cible) return;
      n2 = { b, cible };
      cible.hidden = false;
      cible.scrollTop = 0;
      void cible.offsetWidth;
      cible.classList.add('is-actif');
      niveaux.classList.add('is-n2');
      b.setAttribute('aria-expanded', 'true');
      apres(cible, 260, () => {
        if (!n2 || n2.cible !== cible) return;
        n1.inert = true;
        const r = cible.querySelector('[data-vs13-retour]');
        if (r) r.focus({ preventScroll: true });
      });
    };

    const ouvrirT = () => {
      if (tiroir.open) return;
      tiroir.classList.remove('is-ferme');
      tiroir.showModal();
      document.documentElement.classList.add('vs13-verrou');
      bouton.setAttribute('aria-expanded', 'true');
      feuille.focus({ preventScroll: true });
      requestAnimationFrame(() => requestAnimationFrame(() => tiroir.classList.add('is-ouvert')));
    };

    const nettoyer = () => {
      tiroir.classList.remove('is-ouvert', 'is-ferme');
      document.documentElement.classList.remove('vs13-verrou');
      bouton.setAttribute('aria-expanded', 'false');
      retour(true);
    };

    const fermerT = () => {
      if (!tiroir.open || tiroir.classList.contains('is-ferme')) return;
      tiroir.classList.add('is-ferme');
      tiroir.classList.remove('is-ouvert');
      bouton.setAttribute('aria-expanded', 'false');
      apres(feuille, 220, () => {
        if (!tiroir.classList.contains('is-ferme')) return;
        tiroir.close();
        nettoyer();
        bouton.focus({ preventScroll: true });
      });
    };

    bouton.addEventListener('click', ouvrirT);
    tiroir.querySelector('[data-vs13-fermer]').addEventListener('click', fermerT);
    /* Échap : fermeture animée ; si le navigateur ferme quand même (Échap répété), l'état est remis */
    tiroir.addEventListener('cancel', (e) => { e.preventDefault(); fermerT(); });
    tiroir.addEventListener('close', nettoyer);
    /* clic sur le fond (hors de la feuille) */
    tiroir.addEventListener('click', (e) => { if (e.target === tiroir) fermerT(); });
    tiroir.querySelectorAll('[data-vs13-vers]').forEach((b) => b.addEventListener('click', () => aller(b)));
    tiroir.querySelectorAll('[data-vs13-retour]').forEach((b) => b.addEventListener('click', () => retour(false)));
    large.addEventListener('change', () => { if (large.matches && tiroir.open) { tiroir.close(); } });
  }
})();

/* Halezia, passe 13 (02/11/2026) : le tiroir panier à nous (snippet vs13-panier, feuille 99-vs13-panier.css).
   Honey garde l'enveloppe <cart-drawer> et redessine #CartDrawer après un ajout depuis une fiche ; ici : « + » et « − »
   (le chiffre change tout de suite, la requête part 280 ms après le dernier appui), « Retirer » (la ligne sort, puis
   « Annuler » pendant 6 s), la suggestion (ajout sans quitter le tiroir, « Total avec lui » recalculé au choix de la
   taille). Chaque action : /cart/change.js ou /cart/add.js avec les sections cart-drawer et cart-icon-bubble, une à la
   fois (file d'attente) ; le contenu du tiroir est remplacé par celui du serveur (total = Shopify, remise comprise), le
   défilement et le focus sont gardés. Pendant le calcul : total pâli, barre fine en haut du pied, « Commander » inactif. */
(() => {
  const tiroir = document.querySelector('cart-drawer');
  if (!tiroir || !tiroir.querySelector('.drawer__inner.vsp')) return;
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  let file = Promise.resolve(), enCours = 0, annul = null;

  const inner = () => tiroir.querySelector('.drawer__inner');
  /* identité d'une ligne : la variante (la clé de ligne de Shopify change quand la remise de la commande change) */
  const cles = () => new Set([...tiroir.querySelectorAll('.vsp-ligne[data-variante]')].map((l) => l.dataset.variante));
  const ligneDe = (v) => tiroir.querySelector('.vsp-ligne[data-variante="' + CSS.escape(String(v)) + '"]');
  const plis = () => { const o = tiroir.querySelector('[data-vs-offre]'); return o ? parseInt(o.dataset.vsOffre, 10) || 0 : 0; };
  const euros = (c) => (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

  /* ce qui vient d'arriver : la ligne glisse, le pli tombe sur la pile (jamais au chargement de la page) */
  function marquer(avant, plisAvant) {
    if (reduit.matches) return;
    tiroir.querySelectorAll('.vsp-ligne[data-variante]').forEach((l) => { if (avant && !avant.has(l.dataset.variante)) l.classList.add('is-neuve'); });
    const n = plis();
    if (n > plisAvant) tiroir.querySelectorAll('.vsp-offre__palier.is-plein').forEach((p, i) => { if (i >= plisAvant && i < n) p.classList.add('is-neuf'); });
  }

  function annoncer(t) { const a = tiroir.querySelector('[data-vsp-annonce]'); if (a) a.textContent = t; }

  function appliquer(sections, info) {
    const html = sections && sections['cart-drawer'];
    if (!html) return recharger(info);
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const neuf = doc.querySelector('#CartDrawer .drawer__inner');
    const vieux = inner();
    if (!neuf || !vieux) return;
    const corps = vieux.querySelector('[data-vsp-corps]'), haut = corps ? corps.scrollTop : 0;
    const avant = cles(), plisAvant = plis();
    vieux.innerHTML = neuf.innerHTML;
    const vide = !tiroir.querySelector('.vsp-ligne');
    if (tiroir.classList.contains('is-empty') !== vide) tiroir.classList.toggle('is-empty', vide);
    const c2 = vieux.querySelector('[data-vsp-corps]');
    if (c2) c2.scrollTop = haut;
    const bulle = document.getElementById('cart-icon-bubble');
    if (bulle && sections['cart-icon-bubble']) {
      const s = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (s) bulle.innerHTML = s.innerHTML;
    }
    marquer(avant, plisAvant);
    if (info && info.annul) poserAnnul(info.annul);
    focus(info);
    const total = tiroir.querySelector('[data-vsp-total]');
    if (info && info.dire) annoncer(info.dire + (total ? '. Total ' + total.textContent.trim() : ''));
  }

  /* le focus revient au même bouton de la même ligne ; sinon à la ligne suivante, sinon au titre ; le piège du focus
     de Honey est reposé sur le contenu neuf */
  function focus(info) {
    if (!info || !tiroir.classList.contains('active')) return;
    let cible = null;
    if (info.variante && info.role) { const l = ligneDe(info.variante); if (l) cible = l.querySelector('[data-vsp-role="' + info.role + '"]'); }
    if (!cible && info.annul) cible = tiroir.querySelector('[data-vsp-annuler]');
    if (!cible && info.role === 'sugg') cible = tiroir.querySelector('.vsp-ligne.is-neuve .vsp-ligne__nom') || tiroir.querySelector('.vsp__commander');
    if (!cible && info.index != null) {
      const l = tiroir.querySelectorAll('.vsp-ligne')[info.index] || [...tiroir.querySelectorAll('.vsp-ligne')].pop();
      if (l) cible = l.querySelector('[data-vsp-role="plus"]');
    }
    if (!cible) cible = tiroir.querySelector('.vsp__fermer');
    const conteneur = document.getElementById('CartDrawer');
    if (typeof trapFocus === 'function' && conteneur) trapFocus(conteneur, cible);
    else if (cible) cible.focus({ preventScroll: true });
  }

  function recharger(info) {
    return fetch(window.location.pathname + '?sections=' + SECTIONS.join(','), { headers: { Accept: 'application/json' } })
      .then((r) => r.json()).then((s) => appliquer(s, info));
  }

  function envoyer(url, corps) {
    corps.sections = SECTIONS;
    corps.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corps) })
      .then((r) => r.json().then((j) => { if (!r.ok || j.status) throw j; return j; }));
  }

  function planifier(action, info) {
    enCours++;
    tiroir.classList.add('is-calcul');
    file = file.then(action)
      .then((j) => appliquer(j.sections, info))
      .catch((err) => {
        const msg = (err && (err.description || err.message)) || 'Le panier n’a pas pu être mis à jour. Réessayez.';
        return recharger(info).then(() => {
          const lg = info && info.variante ? ligneDe(info.variante) : null, l = lg ? lg.querySelector('[data-vsp-erreur]') : null;
          const zone = l || tiroir.querySelector('[data-vsp-annonce]');
          if (zone) { zone.textContent = msg; zone.hidden = false; }
        }).catch(() => {});
      })
      .finally(() => { if (--enCours === 0) tiroir.classList.remove('is-calcul'); });
  }

  /* « + » et « − » : le chiffre suit le doigt, une seule requête à la fin des appuis */
  function changerQte(ligne, d, role) {
    const n = ligne.querySelector('[data-vsp-n]');
    const avant = parseInt(ligne.dataset.voulu || ligne.dataset.qte, 10) || 1;
    const v = avant + d;
    if (v < 1) return retirer(ligne);
    ligne.dataset.voulu = String(v);
    if (n) {
      n.textContent = String(v);
      n.classList.remove('is-monte', 'is-descend'); void n.offsetWidth;
      n.classList.add(d > 0 ? 'is-monte' : 'is-descend');
    }
    ligne.classList.add('is-attente');
    tiroir.classList.add('is-calcul');
    const variante = ligne.dataset.variante, titre = ligne.dataset.titre || '';
    clearTimeout(ligne._vspTempo);
    ligne._vspTempo = setTimeout(() => {
      /* la clé est lue au moment d'envoyer : un rendu arrivé entre-temps a pu la changer */
      planifier(() => { const l = ligneDe(variante); return envoyer('/cart/change.js', { id: l ? l.dataset.key : variante, quantity: v }); },
        { variante, role, dire: titre + ' : quantité ' + v });
    }, 280);
  }

  function retirer(ligne) {
    const variante = ligne.dataset.variante, index = [...tiroir.querySelectorAll('.vsp-ligne')].indexOf(ligne);
    const annulInfo = { id: parseInt(ligne.dataset.variante, 10), quantity: parseInt(ligne.dataset.qte, 10) || 1, titre: ligne.dataset.titre || 'Article' };
    clearTimeout(ligne._vspTempo);
    if (!reduit.matches) ligne.classList.add('is-sortie');
    const attendre = reduit.matches ? Promise.resolve() : new Promise((ok) => setTimeout(ok, 240));
    planifier(() => attendre.then(() => { const l = ligneDe(variante); return envoyer('/cart/change.js', { id: l ? l.dataset.key : variante, quantity: 0 }); }),
      { index, annul: annulInfo, dire: annulInfo.titre + ' retiré du panier' });
  }

  function poserAnnul(a) {
    clearTimeout(annul && annul.tempo);
    const zone = tiroir.querySelector('[data-vsp-lignes]') || tiroir.querySelector('.vsp-vide');
    if (!zone) return;
    const barre = document.createElement('div');
    barre.className = 'vsp-annul';
    barre.setAttribute('role', 'status');
    const t = document.createElement('span');
    t.textContent = a.titre + ' retiré.';
    const b = document.createElement('button');
    b.type = 'button'; b.textContent = 'Annuler'; b.setAttribute('data-vsp-annuler', '');
    barre.append(t, b);
    zone.parentNode.insertBefore(barre, zone);
    annul = { a, barre, tempo: setTimeout(() => { barre.classList.add('is-fin'); setTimeout(() => barre.remove(), 260); annul = null; }, 6000) };
  }

  tiroir.addEventListener('click', (e) => {
    const q = e.target.closest('[data-vsp-qte]');
    if (q) { e.preventDefault(); const l = q.closest('.vsp-ligne'); if (l) changerQte(l, parseInt(q.dataset.vspQte, 10), q.dataset.vspRole); return; }
    const r = e.target.closest('[data-vs-retirer]');
    if (r && r.closest('.vsp')) { e.preventDefault(); e.stopPropagation(); const l = r.closest('.vsp-ligne'); if (l) retirer(l); return; }
    const u = e.target.closest('[data-vsp-annuler]');
    if (u && annul) {
      e.preventDefault();
      const a = annul.a; clearTimeout(annul.tempo); annul.barre.remove(); annul = null;
      planifier(() => envoyer('/cart/add.js', { items: [{ id: a.id, quantity: a.quantity }] }), { role: 'sugg', dire: a.titre + ' remis dans le panier' });
    }
  });

  /* la suggestion : ajout dans le tiroir ; « Total avec lui » suit la taille choisie (mêmes paliers, arrondi au centime) */
  tiroir.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-vsp-sugg-form]');
    if (!f) return;
    e.preventDefault();
    const id = parseInt(f.querySelector('[name="id"]').value, 10), b = f.querySelector('[type="submit"]');
    if (b) b.setAttribute('aria-busy', 'true');
    const nomP = (f.querySelector('.vsp-sugg__nom') || {}).textContent || 'Plaid';
    planifier(() => envoyer('/cart/add.js', { items: [{ id, quantity: 1 }] }), { role: 'sugg', dire: nomP.trim() + ' ajouté au panier' });
  });
  tiroir.addEventListener('change', (e) => {
    const s = e.target.closest('.vsp-sugg__choix');
    if (!s) return;
    e.stopPropagation();
    const f = s.closest('[data-vsp-sugg-form]'), g = f && f.querySelector('[data-vsp-gain]');
    const o = s.options[s.selectedIndex];
    const img = f && f.closest('.vsp-sugg__carte') && f.closest('.vsp-sugg__carte').querySelector('.vsp-sugg__image');
    if (!g || f.hasAttribute('data-code') || !o) return;
    const sous = parseInt(f.dataset.sous, 10) + parseInt(o.dataset.prix, 10), rn = parseInt(f.dataset.rn, 10) || 0;
    const total = sous - Math.floor((sous * rn) / 100);   /* arrondi inférieur, comme Shopify (12,70 € pour 15 % de 84,70 €) */
    g.querySelector('[data-vsp-gain-total]').textContent = euros(total);
    g.querySelector('[data-vsp-gain-sans]').textContent = euros(sous);
  }, true);

  /* entrée en cascade : seulement à l'ouverture ; la classe vsp-pose l'arrête une fois le tiroir posé. L'observateur
     ne touche la classe que si elle doit changer : retirer une classe absente réécrit quand même l'attribut, ce qui
     relançait l'observateur sans fin (page figée, trouvé par le contrôle du 02/11). */
  let pose = null;
  new MutationObserver(() => {
    const actif = tiroir.classList.contains('active'), pos = tiroir.classList.contains('vsp-pose');
    if (actif) {
      if (!pose && !pos) pose = setTimeout(() => { pose = null; if (tiroir.classList.contains('active')) tiroir.classList.add('vsp-pose'); }, 900);
    } else {
      if (pose) { clearTimeout(pose); pose = null; }
      if (pos) tiroir.classList.remove('vsp-pose');
    }
  }).observe(tiroir, { attributes: true, attributeFilter: ['class'] });

  /* ajout depuis une fiche ou une carte : Honey redessine #CartDrawer ; on marque ce qui vient d'arriver */
  if (window.customElements) {
    customElements.whenDefined('cart-drawer').then(() => {
      const C = customElements.get('cart-drawer');
      if (!C || C.prototype._vspEnveloppe) return;
      const rc = C.prototype.renderContents;
      C.prototype.renderContents = function (etat) {
        const avant = cles(), plisAvant = plis(), etaitOuvert = this.classList.contains('active');
        rc.call(this, etat);
        const vide = !this.querySelector('.vsp-ligne');
        if (this.classList.contains('is-empty') !== vide) this.classList.toggle('is-empty', vide);
        if (etaitOuvert && !this.classList.contains('vsp-pose')) this.classList.add('vsp-pose');
        else if (!etaitOuvert && this.classList.contains('vsp-pose')) this.classList.remove('vsp-pose');
        marquer(avant, plisAvant);
      };
      C.prototype._vspEnveloppe = true;
    });
  }
})();
